(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fAf6U", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b585f06cc1ada5a1$export$6503ec6e8aabbaf; }, function (v) { return $b585f06cc1ada5a1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b585f06cc1ada5a1$export$f7ad0328861e2f03; }, function (v) { return $b585f06cc1ada5a1$export$f7ad0328861e2f03 = v; });
var $b585f06cc1ada5a1$export$6503ec6e8aabbaf;
var $b585f06cc1ada5a1$export$f7ad0328861e2f03;
"use strict";
var $b585f06cc1ada5a1$var$mapping = new Map();
function $b585f06cc1ada5a1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b585f06cc1ada5a1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b585f06cc1ada5a1$var$resolve(id) {
    var resolved = $b585f06cc1ada5a1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b585f06cc1ada5a1$export$6503ec6e8aabbaf = $b585f06cc1ada5a1$var$register;
$b585f06cc1ada5a1$export$f7ad0328861e2f03 = $b585f06cc1ada5a1$var$resolve;

});

parcelRegister("beFBT", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $82e1476b92937b83$export$bdfd709ae4826697; }, function (v) { return $82e1476b92937b83$export$bdfd709ae4826697 = v; });
var $82e1476b92937b83$export$bdfd709ae4826697;
var $82e1476b92937b83$export$c9e73fbda7da57b6;
var $82e1476b92937b83$export$5a759dc7a1cfb72a;
"use strict";
var $82e1476b92937b83$var$bundleURL = {};
function $82e1476b92937b83$var$getBundleURLCached(id) {
    var value = $82e1476b92937b83$var$bundleURL[id];
    if (!value) {
        value = $82e1476b92937b83$var$getBundleURL();
        $82e1476b92937b83$var$bundleURL[id] = value;
    }
    return value;
}
function $82e1476b92937b83$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $82e1476b92937b83$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $82e1476b92937b83$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $82e1476b92937b83$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$82e1476b92937b83$export$bdfd709ae4826697 = $82e1476b92937b83$var$getBundleURLCached;
$82e1476b92937b83$export$c9e73fbda7da57b6 = $82e1476b92937b83$var$getBaseURL;
$82e1476b92937b83$export$5a759dc7a1cfb72a = $82e1476b92937b83$var$getOrigin;

});

parcelRegister("do71c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
function $9bf2f5f236b42877$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $9bf2f5f236b42877$var$ConfigProxyManagerImpl {
    constructor(messenger){
        $9bf2f5f236b42877$var$_defineProperty(this, "_config", {});
        $9bf2f5f236b42877$var$_defineProperty(this, "messenger", void 0);
        $9bf2f5f236b42877$var$_defineProperty(this, "config", ()=>this._config);
        this.messenger = messenger;
    }
    clear(key, cb) {
        if (key) {
            delete this._config[key];
            cb && this.messenger.setCallback(cb, null);
            return;
        }
        this._config = {};
    }
    get(key) {
        if (key.includes("/")) {
            const nestedKeys = key.split("/");
            const rollupObject = nestedKeys[0];
            const apiName = nestedKeys[1];
            return this._config[rollupObject] && this._config[rollupObject][apiName];
        }
        return this._config[key];
    }
    set(updates) {
        for(const updateKey in updates)if (updateKey.includes("/")) {
            const nestedKeys = updateKey.split("/");
            const rollupObject = nestedKeys[0];
            const apiName = nestedKeys[1];
            this._config = {
                ...this._config,
                [rollupObject]: {
                    ...this._config[rollupObject],
                    [apiName]: updates[updateKey]
                }
            };
        }
        this.messenger.send($lg0Zk.Events.SHELL_SETTINGS, updates);
        this._config = {
            ...this._config,
            ...updates
        };
    }
    update(key, value, callbackName, forceReset) {
        const newValue = {
            ...value
        };
        const cb = newValue.callback;
        if (cb || forceReset) {
            delete newValue.callback;
            this.messenger.setCallback(callbackName, cb);
        }
        const current = this.get(key) || {};
        this.set({
            [key]: Object.assign(current, newValue)
        });
    }
    setupConfig(obj, keys, setCallback, rollupObject) {
        keys.forEach((apiName)=>{
            Object.defineProperty(obj, apiName, {
                get: ()=>{
                    // Remove rollupObject argument and if statements once 'sidebar' api
                    // can be fully removed since this is now handled in the configProxy set and get
                    if (rollupObject) {
                        const object = this.get(rollupObject);
                        return object[apiName];
                    }
                    return this.get(apiName);
                },
                set: (value)=>{
                    setCallback && setCallback(apiName, value);
                    if (rollupObject) {
                        this.set({
                            [rollupObject]: {
                                [apiName]: value
                            }
                        });
                        return;
                    }
                    this.set({
                        [apiName]: value
                    });
                }
            });
        });
    }
}
var $9bf2f5f236b42877$var$_default = (messenger)=>new $9bf2f5f236b42877$var$ConfigProxyManagerImpl(messenger);
module.exports.default = $9bf2f5f236b42877$var$_default;

});
parcelRegister("lg0Zk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.markEventsPerformance = $f79bdbcfde5e1829$var$markEventsPerformance;
module.exports.extractTokenMetadata = $f79bdbcfde5e1829$var$extractTokenMetadata;
module.exports.getOperationName = $f79bdbcfde5e1829$var$getOperationName;
Object.defineProperty(module.exports, "Events", {
    enumerable: true,
    get: function() {
        return $6mfMq.Events;
    }
});
Object.defineProperty(module.exports, "EventsThirdParty", {
    enumerable: true,
    get: function() {
        return $6mfMq.EventsThirdParty;
    }
});
module.exports.isAWSOrgRegion = module.exports.digitalDataUpdated = module.exports.sanitizeConfiguration = module.exports.KEYS_WITH_PII = module.exports.runWithTimeout = module.exports.getErrorMessage = module.exports.NOOP = module.exports.wait = module.exports.throttleQueue = module.exports.BROWSER_FILTER_PARAMS = void 0;

var $6mfMq = parcelRequire("6mfMq");
var $f79bdbcfde5e1829$var$__assign = function() {
    $f79bdbcfde5e1829$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f79bdbcfde5e1829$var$__assign.apply(this, arguments);
};
var $f79bdbcfde5e1829$var$DEFAULT_EXPIRES_IN = 3600000; // Contains the events that should be marked.
var $f79bdbcfde5e1829$var$eventsMapping = {};
var $f79bdbcfde5e1829$var$BROWSER_FILTER_PARAMS = new Set([
    "_mr",
    "shell_domain",
    "shell_forceReload"
]);
/**
 * Setup the events marker by using the filter approach documented here:
 * https://git.corp.adobe.com/exc/metrics-sdk-js/blob/master/README.md#filter
 * @param win Window object
 * @param eventsToMark An array of events to be marked
 * @param transformFunc a function to transform event names used to enforce a naming convention.
 */ module.exports.BROWSER_FILTER_PARAMS = $f79bdbcfde5e1829$var$BROWSER_FILTER_PARAMS;
function $f79bdbcfde5e1829$var$markEventsPerformance(win, eventsToMark, transformFunc) {
    if (transformFunc === void 0) transformFunc = function(a) {
        return a;
    };
    var performance = win.performance, internal = win["exc-module-runtime"].internal; // Filter function
    function metricsWrite(record) {
        if (record.event) {
            var events = Array.isArray(record.event) ? record.event : [
                record.event
            ];
            events.forEach(function(event) {
                return event in $f79bdbcfde5e1829$var$eventsMapping && performance.mark($f79bdbcfde5e1829$var$eventsMapping[event]);
            });
        }
        return Promise.resolve(record);
    }
    eventsToMark.forEach(function(event) {
        $f79bdbcfde5e1829$var$eventsMapping[event] = transformFunc(event);
    });
    if (typeof (performance === null || performance === void 0 ? void 0 : performance.mark) === "function") internal.setFilter(metricsWrite);
}
/**
 * Throttle function invocations. Used to batch certain operations such as queue processing.
 * @param fn - Function
 * @param timeout - Throttling timeout (ms)
 * @param immediateAfterIdle - If there were no invocations for the defined period
 * (timeoutMs), process immediatelly.
 * @param win - Window
 */ var $f79bdbcfde5e1829$var$throttleQueue = function(fn, timeout, immediateAfterIdle, win) {
    if (immediateAfterIdle === void 0) immediateAfterIdle = false;
    if (win === void 0) win = window;
    var setTimeout = win.setTimeout;
    var ready = true;
    var lastInvocation = Date.now();
    return function() {
        var _this = this;
        if (ready) {
            if (immediateAfterIdle && Date.now() - lastInvocation > timeout) {
                fn.apply(this);
                lastInvocation = Date.now();
                return;
            }
            ready = false;
            setTimeout(function() {
                fn.apply(_this);
                lastInvocation = Date.now();
                ready = true;
            }, timeout);
        }
    };
};
/**
 * Extracts metadata from the IMS token by base64 decoding the middle section
 * and parsing it into JSON.
 * @param {string} token The IMS token to extract metadata from.
 * @returns {Object} The extracted metadata.
 */ module.exports.throttleQueue = $f79bdbcfde5e1829$var$throttleQueue;
function $f79bdbcfde5e1829$var$extractTokenMetadata(token) {
    try {
        var middleBits = token.split(".")[1];
        var tokenMetadata = JSON.parse(atob(middleBits));
        tokenMetadata.created_at = parseInt(tokenMetadata.created_at, 10) || Date.now();
        tokenMetadata.expires_in = parseInt(tokenMetadata.expires_in, 10) || $f79bdbcfde5e1829$var$DEFAULT_EXPIRES_IN;
        return tokenMetadata;
    } catch (_a) {
        return null;
    }
}
var $f79bdbcfde5e1829$var$wait = function(ms, win) {
    if (win === void 0) win = window;
    return new Promise(function(resolve) {
        return win.setTimeout(resolve, ms);
    });
};
module.exports.wait = $f79bdbcfde5e1829$var$wait;
var $f79bdbcfde5e1829$var$NOOP = function() {};
module.exports.NOOP = $f79bdbcfde5e1829$var$NOOP;
function $f79bdbcfde5e1829$var$getOperationName(query) {
    if (query === void 0) query = "";
     // Extract operation name from query
    var name = /(query|mutation) ?(\w+)/.exec(query);
    return name && name.length ? name[2] : undefined;
}
var $f79bdbcfde5e1829$var$getErrorMessage = function(err, defaultMessage) {
    if (defaultMessage === void 0) defaultMessage = "Unknown Error";
    if (err && typeof err === "object" && typeof err.message === "string") return err.message;
    if (typeof err === "string") return err;
    return defaultMessage;
};
/**
 * Awaits a promise up to a certain timeout.
 * If the timeout is due before the promise resolves, resolves with a predefined payload.
 * @template T
 * @param promise to await.
 * @param timeout - Timeout (ms)
 * @param timeoutResponse - Timeout response
 * @param win - Window
 */ module.exports.getErrorMessage = $f79bdbcfde5e1829$var$getErrorMessage;
var $f79bdbcfde5e1829$var$runWithTimeout = function(promise, timeout, timeoutResponse, win) {
    if (win === void 0) win = window;
    return Promise.race([
        promise,
        new Promise(function(resolve) {
            return win.setTimeout(function() {
                return resolve(timeoutResponse);
            }, timeout);
        })
    ]);
};
module.exports.runWithTimeout = $f79bdbcfde5e1829$var$runWithTimeout;
var $f79bdbcfde5e1829$var$KEYS_WITH_PII = new Set([
    "imsInfo",
    "imsProfile",
    "imsToken",
    "shellInfo"
]);
module.exports.KEYS_WITH_PII = $f79bdbcfde5e1829$var$KEYS_WITH_PII;
var $f79bdbcfde5e1829$var$sanitizeConfiguration = function(config) {
    var sanitized = $f79bdbcfde5e1829$var$__assign({}, config);
    $f79bdbcfde5e1829$var$KEYS_WITH_PII.forEach(function(piiKey) {
        return delete sanitized[piiKey];
    });
    return sanitized;
};
module.exports.sanitizeConfiguration = $f79bdbcfde5e1829$var$sanitizeConfiguration;
var $f79bdbcfde5e1829$var$digitalDataUpdated = function(detail, win) {
    if (win === void 0) win = window;
    return win.dispatchEvent(new CustomEvent("digitalData", {
        detail: detail
    }));
};
/**
 * Validate if the region is an AWS org region for determining the correct URL to hit.
 * @param region - Region to validate.
 * @returns Whether or not the region is an AWS org region.
 */ module.exports.digitalDataUpdated = $f79bdbcfde5e1829$var$digitalDataUpdated;
var $f79bdbcfde5e1829$var$AWS_REGIONS = new Set([
    "VA6"
]);
var $f79bdbcfde5e1829$var$isAWSOrgRegion = function(region) {
    return $f79bdbcfde5e1829$var$AWS_REGIONS.has(region);
};
module.exports.isAWSOrgRegion = $f79bdbcfde5e1829$var$isAWSOrgRegion;

});
parcelRegister("6mfMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = module.exports.EventsThirdParty = void 0;
var $4a1109beeb9f64ed$var$__assign = function() {
    $4a1109beeb9f64ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4a1109beeb9f64ed$var$__assign.apply(this, arguments);
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // Events that are sent by our own code as opposed to messages receieved through API calls
var $4a1109beeb9f64ed$var$InternalEvents = {
    ACTIVE: "ACTIVE",
    CLICK: "CLICK",
    COACH_MARK_POSITIONED: "COACH_MARK_POSITIONED",
    COMPONENT_CLOSE_COMPLETE: "COMPONENT_CLOSE_COMPLETE",
    DEPRECATION_WARNING: "DEPRECATION_WARNING",
    DONE: "DONE",
    FOCUS: "FOCUS",
    GAINSIGHT_INIT: "GAINSIGHT_INIT",
    GLOBAL_DIALOG_OPEN: "GLOBAL_DIALOG_OPEN",
    HERO_CLICK: "HERO_CLICK",
    HISTORY: "HISTORY",
    KEYPRESS: "KEYPRESS",
    LOST_AUTH: "LOST_AUTH",
    NOT_INITIALIZED: "NOT_INITIALIZED",
    NPS: "NPS",
    PING: "PING",
    PONG: "PONG",
    QUEUE: "QUEUE",
    READY: "READY",
    RECENT_EVENT: "RECENT_EVENT",
    SKIP_MENU_FOCUS: "SKIP_MENU_FOCUS",
    TOAST_SUPRESSED: "TOAST_SUPRESSED",
    USER_INPUT: "USER_INPUT"
}; // Internal events and APIs that are approved for 3rd party use
var $4a1109beeb9f64ed$var$EventsThirdParty = $4a1109beeb9f64ed$var$__assign($4a1109beeb9f64ed$var$__assign({}, $4a1109beeb9f64ed$var$InternalEvents), {
    AUTH_EXPIRATION: "AUTH_EXPIRATION",
    BLOCK_NAVIGATION: "BLOCK_NAVIGATION",
    CAN_TAKEOVER: "CAN_TAKEOVER",
    CONFIGURE: "CONFIGURE",
    CUSTOM_FEEDBACK: "CUSTOM_FEEDBACK",
    CUSTOM_HELP_BUTTON_CLICK: "CUSTOM_HELP_BUTTON_CLICK",
    CUSTOM_SEARCH: "CUSTOM_SEARCH",
    DATA_FULFILL: "DATA_FULFILL",
    DATA_REQUEST: "DATA_REQUEST",
    IFRAME_RELOAD: "IFRAME_RELOAD",
    MODULES_DATA: "MODULES_DATA",
    NOT_FOUND: "NOT_FOUND",
    OPEN_HELP_CENTER: "OPEN_HELP_CENTER",
    PERMISSIONS: "PERMISSIONS",
    SHELL_REDIRECT: "SHELL_REDIRECT",
    SHELL_SETTINGS: "SHELL_SETTINGS",
    SKIP_MENU_GET_LIST: "SKIP_MENU_GET_LIST",
    SKIP_MENU_SET_LIST: "SKIP_MENU_SET_LIST"
}); // All internal events and APIs
module.exports.EventsThirdParty = $4a1109beeb9f64ed$var$EventsThirdParty;
var $4a1109beeb9f64ed$var$Events = $4a1109beeb9f64ed$var$__assign($4a1109beeb9f64ed$var$__assign({}, $4a1109beeb9f64ed$var$EventsThirdParty), {
    AEM_INSTANCES: "AEM_INSTANCES",
    AFTER_PRINT_HANDLER: "AFTER_PRINT_HANDLER",
    AI_MESSAGE: "AI_MESSAGE",
    APP_CACHE: "APP_CACHE",
    APP_DATA: "APP_DATA",
    BEFORE_PRINT_HANDLER: "BEFORE_PRINT_HANDLER",
    CLIPBOARD_WRITE: "CLIPBOARD_WRITE",
    COMPONENT_CLOSE: "COMPONENT_CLOSE",
    COMPONENT_OPEN: "COMPONENT_OPEN",
    CONSENT_GET: "CONSENT_GET",
    CONSENT_UPDATE: "CONSENT_UPDATE",
    CUSTOM_HERO_CLICK: "CUSTOM_HERO_CLICK",
    CUSTOM_LEFT_NAV_CLICK: "CUSTOM_LEFT_NAV_CLICK",
    CUSTOM_PROFILE_BUTTON_CLICK: "CUSTOM_PROFILE_BUTTON_CLICK",
    CUSTOM_PROFILE_CLICK: "CUSTOM_PROFILE_CLICK",
    CUSTOM_TOKEN: "CUSTOM_TOKEN",
    DATA_PREFETCH: "DATA_PREFETCH",
    EXC_PULSE: "EXC_PULSE",
    EXC_SETTINGS: "EXC_SETTINGS",
    EXTENDED_SHELL_INFO: "EXTENDED_SHELL_INFO",
    FEATURE_FLAGS: "FEATURE_FLAGS",
    FEEDBACK_CONFIG: "FEEDBACK_CONFIG",
    FULFILLABLE_ITEMS: "FULFILLABLE_ITEMS",
    GENERATE_SUBORG: "GENERATE_SUBORG",
    JIRA_SUBMIT: "JIRA_SUBMIT",
    NAV_ITEM_CLICK: "NAV_ITEM_CLICK",
    PRINT_NOW: "PRINT_NOW",
    PULSE_BUTTON: "PULSE_BUTTON",
    RUNTIME_REQ: "RUNTIME_REQ",
    RUNTIME_RESP: "RUNTIME_RESP",
    SESSION: "SESSION",
    SPA_SRC_DOC: "SPA_SRC_DOC",
    TITLE: "TITLE",
    TRIGGER_NPS: "TRIGGER_NPS"
});
module.exports.Events = $4a1109beeb9f64ed$var$Events;

});



parcelRegister("9s7Ng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.done = void 0;

var $fvvQI = parcelRequire("fvvQI");
function $6e1cc63c7fec3a64$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $6e1cc63c7fec3a64$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $6e1cc63c7fec3a64$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6e1cc63c7fec3a64$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $6e1cc63c7fec3a64$var$getDeferredEngine = (messenger, configManager, listeners, metricsApi, window)=>{
    let deferredImport;
    return ()=>{
        if (!deferredImport) deferredImport = Promise.resolve().then(function() {
            return (parcelRequire("hwTLm"));
        }).then((res)=>$6e1cc63c7fec3a64$var$_interopRequireWildcard(res)).then(({ default: createEngine })=>createEngine(messenger, configManager, listeners, metricsApi, window));
        return deferredImport;
    };
};

const $6e1cc63c7fec3a64$var$done = (timestamp, messenger, metricsApi, win)=>Promise.resolve().then(function() {
        return (parcelRequire("hwTLm"));
    }).then((res)=>$6e1cc63c7fec3a64$var$_interopRequireWildcard(res)).then(({ done: doneSync })=>doneSync(timestamp, messenger, metricsApi, win));
module.exports.done = $6e1cc63c7fec3a64$var$done;
const $6e1cc63c7fec3a64$var$passForward = (apiName, method, deferred)=>(...args)=>deferred().then(({ modules: modules })=>modules[apiName]).then((module)=>module[method](...args));
const $6e1cc63c7fec3a64$var$composeApi = ({ base: base = {}, methods: methods, properties: properties = [], name: name }, config, deferred)=>{
    // Set api base structure
    const api = {
        ...base
    }; // Add methods
    methods.forEach((method)=>api[method] = $6e1cc63c7fec3a64$var$passForward(name, method, deferred)); // Add properties
    properties.forEach((property)=>{
        const key = property.includes("/") ? property.split("/")[1] : property;
        Object.defineProperty(api, key, {
            get: ()=>config.get(property),
            set: (value)=>config.set({
                    [property]: value
                })
        });
    });
    return ()=>api;
};
const $6e1cc63c7fec3a64$var$createModules = (configManager, deferred)=>({
        ai: $6e1cc63c7fec3a64$var$composeApi($fvvQI.aiRecipe, configManager, deferred),
        appApi: $6e1cc63c7fec3a64$var$composeApi($fvvQI.appRecipe, configManager, deferred),
        cache: $6e1cc63c7fec3a64$var$composeApi($fvvQI.cacheRecipe, configManager, deferred),
        component: $6e1cc63c7fec3a64$var$composeApi($fvvQI.componentRecipe, configManager, deferred),
        consent: $6e1cc63c7fec3a64$var$composeApi($fvvQI.consentRecipe, configManager, deferred),
        featureFlags: $6e1cc63c7fec3a64$var$composeApi($fvvQI.featureFlagsRecipe, configManager, deferred),
        modules: $6e1cc63c7fec3a64$var$composeApi($fvvQI.modulesRecipe, configManager, deferred),
        networkPrefetch: $6e1cc63c7fec3a64$var$composeApi($fvvQI.networkPrefetchRecipe, configManager, deferred),
        permissions: $6e1cc63c7fec3a64$var$composeApi($fvvQI.permissionsRecipe, configManager, deferred),
        pulse: $6e1cc63c7fec3a64$var$composeApi($fvvQI.pulseRecipe, configManager, deferred),
        session: $6e1cc63c7fec3a64$var$composeApi($fvvQI.sessionRecipe, configManager, deferred),
        settings: $6e1cc63c7fec3a64$var$composeApi($fvvQI.settingsRecipe, configManager, deferred),
        shell: $6e1cc63c7fec3a64$var$composeApi($fvvQI.shellRecipe, configManager, deferred),
        sidenav: $6e1cc63c7fec3a64$var$composeApi($fvvQI.sidenavRecipe, configManager, deferred),
        user: $6e1cc63c7fec3a64$var$composeApi($fvvQI.userRecipe, configManager, deferred)
    });
var $6e1cc63c7fec3a64$var$_default = (messenger, configManager, listeners, metricsApi, window)=>{
    const deferred = $6e1cc63c7fec3a64$var$getDeferredEngine(messenger, configManager, listeners, metricsApi, window);
    const deferredMethod = (method)=>(...args)=>deferred().then((engineModule)=>engineModule[method](...args));
    const modules = $6e1cc63c7fec3a64$var$createModules(configManager, deferred);
    const app = ()=>deferred().then(({ modules: modulesSync })=>modulesSync.app);
    const configurePromise = deferred().then(({ configurePromise: promise })=>promise);
    return {
        app: app,
        configurePromise: configurePromise,
        modules: modules,
        onConfigure: (runtime, config, internal)=>deferredMethod("onConfigure")(runtime, config, internal),
        onPageChange: (runtime)=>deferredMethod("onPageChange")(runtime),
        onShellUserInput: (e)=>deferredMethod("onShellUserInput")(e),
        waitForInit: (runtimeInstance)=>deferredMethod("waitForInit")(runtimeInstance)
    };
};
module.exports.default = $6e1cc63c7fec3a64$var$_default;

});
parcelRegister("fvvQI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userRecipe = module.exports.sidenavRecipe = module.exports.shellRecipe = module.exports.settingsRecipe = module.exports.sessionRecipe = module.exports.pulseRecipe = module.exports.networkPrefetchRecipe = module.exports.modulesRecipe = module.exports.permissionsRecipe = module.exports.featureFlagsRecipe = module.exports.consentRecipe = module.exports.componentRecipe = module.exports.cacheRecipe = module.exports.appRecipe = module.exports.aiRecipe = void 0;

var $eemdr = parcelRequire("eemdr");
// AI API recipe
const $b4a274dac09a6fcc$var$aiRecipe = {
    methods: [
        "closeChat",
        "emit",
        "off",
        "on",
        "onContextRequest",
        "openChat",
        "sendMessage",
        "showAssistant"
    ],
    name: "ai",
    properties: [
        "ai/context"
    ]
}; // App API recipe
module.exports.aiRecipe = $b4a274dac09a6fcc$var$aiRecipe;
const $b4a274dac09a6fcc$var$appRecipe = {
    methods: [
        "get"
    ],
    name: "app"
}; // Cache API recipe
module.exports.appRecipe = $b4a274dac09a6fcc$var$appRecipe;
const $b4a274dac09a6fcc$var$cacheRecipe = {
    methods: [
        "delete",
        "get",
        "set"
    ],
    name: "cache"
}; // Modules API recipe
module.exports.cacheRecipe = $b4a274dac09a6fcc$var$cacheRecipe;
const $b4a274dac09a6fcc$var$modulesRecipe = {
    methods: [
        "get",
        "getSrcDoc"
    ],
    name: "modules"
}; // Component API recipe
module.exports.modulesRecipe = $b4a274dac09a6fcc$var$modulesRecipe;
const $b4a274dac09a6fcc$var$componentRecipe = {
    methods: [
        "close",
        "isComponent",
        "open"
    ],
    name: "component"
}; // Consent API recipe
module.exports.componentRecipe = $b4a274dac09a6fcc$var$componentRecipe;
const $b4a274dac09a6fcc$var$consentRecipe = {
    methods: [
        "getPermissions",
        "updatePermissions"
    ],
    name: "consent"
}; // Feature Flags API
module.exports.consentRecipe = $b4a274dac09a6fcc$var$consentRecipe;
const $b4a274dac09a6fcc$var$featureFlagsRecipe = {
    methods: [
        "get"
    ],
    name: "featureFlags"
}; // Network Prefetch API recipe
module.exports.featureFlagsRecipe = $b4a274dac09a6fcc$var$featureFlagsRecipe;
const $b4a274dac09a6fcc$var$networkPrefetchRecipe = {
    methods: [
        "prefetch"
    ],
    name: "networkPrefetch"
}; // Permissions API recipe
module.exports.networkPrefetchRecipe = $b4a274dac09a6fcc$var$networkPrefetchRecipe;
const $b4a274dac09a6fcc$var$permissionsRecipe = {
    methods: [
        "get"
    ],
    name: "permissions"
}; // Pulse API recipe
module.exports.permissionsRecipe = $b4a274dac09a6fcc$var$permissionsRecipe;
const $b4a274dac09a6fcc$var$pulseRecipe = {
    methods: [
        "send",
        "setCount",
        "setButton"
    ],
    name: "pulse"
}; // Session API recipe
module.exports.pulseRecipe = $b4a274dac09a6fcc$var$pulseRecipe;
const $b4a274dac09a6fcc$var$sessionRecipe = {
    methods: [
        "get",
        "invalidate",
        "set"
    ],
    name: "session"
}; // Settings API recipe
module.exports.sessionRecipe = $b4a274dac09a6fcc$var$sessionRecipe;
const $b4a274dac09a6fcc$var$settingsRecipe = {
    base: {
        SETTINGS_LEVEL: $eemdr.SettingsLevel
    },
    methods: [
        "get",
        "set"
    ],
    name: "settings"
}; // Shell API recipe
module.exports.settingsRecipe = $b4a274dac09a6fcc$var$settingsRecipe;
const $b4a274dac09a6fcc$var$shellRecipe = {
    methods: [
        "emit",
        "get",
        "getExtendedShellInfo",
        "off",
        "on"
    ],
    name: "shell"
}; // User API recipe
module.exports.shellRecipe = $b4a274dac09a6fcc$var$shellRecipe;
const $b4a274dac09a6fcc$var$userRecipe = {
    methods: [
        "authExpired",
        "emit",
        "generateSubOrg",
        "get",
        "getAEMInstances",
        "getFulfillableItems",
        "off",
        "on"
    ],
    name: "user",
    properties: [
        "logoutUrl",
        "showLanguagePicker",
        "showRolesPicker"
    ]
}; // Sidenav API recipe
module.exports.userRecipe = $b4a274dac09a6fcc$var$userRecipe;
const $b4a274dac09a6fcc$var$sidenavRecipe = {
    methods: [
        "emit",
        "get",
        "off",
        "on",
        "onNavItemClick",
        "useLeftNavButton"
    ],
    name: "sidenav",
    properties: [
        "sidenav/visible",
        "sidenav/collapsed",
        "sidenav/config"
    ]
};
module.exports.sidenavRecipe = $b4a274dac09a6fcc$var$sidenavRecipe;

});
parcelRegister("eemdr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsLevel = void 0;
/*************************************************************************
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @ignore
 */ let $b48c3ed2dab11418$var$SettingsLevel;
module.exports.SettingsLevel = $b48c3ed2dab11418$var$SettingsLevel;
(function(SettingsLevel) {
    SettingsLevel["ORG"] = "org";
    SettingsLevel["USER"] = "user";
    SettingsLevel["USERORG"] = "userorg";
})($b48c3ed2dab11418$var$SettingsLevel || (module.exports.SettingsLevel = $b48c3ed2dab11418$var$SettingsLevel = {}));

});


parcelRegister("hwTLm", function(module, exports) {


module.exports = (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("4tLhU")).then(()=>parcelRequire("b6DgD"));

});
parcelRegister("8msKY", function(module, exports) {
"use strict";

var $8y3Xx = parcelRequire("8y3Xx");
module.exports = $8y3Xx(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("8y3Xx", function(module, exports) {
"use strict";
var $639491ed06178403$var$cachedBundles = {};
var $639491ed06178403$var$cachedPreloads = {};
var $639491ed06178403$var$cachedPrefetches = {};
function $639491ed06178403$var$getCache(type) {
    switch(type){
        case "preload":
            return $639491ed06178403$var$cachedPreloads;
        case "prefetch":
            return $639491ed06178403$var$cachedPrefetches;
        default:
            return $639491ed06178403$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $639491ed06178403$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("iZrqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
const $dd3331e3f91ca419$var$getButtons = (buttonConfig)=>{
    if (!buttonConfig) return [];
    return Array.isArray(buttonConfig) ? buttonConfig : [
        buttonConfig
    ];
};
var $dd3331e3f91ca419$var$_default = (messenger, configManager, metricsApi)=>{
    const metrics = metricsApi.create("exc.module-runtime.helpCenter");
    const scopes = [
        "helpCenter",
        "helpCenterResource"
    ];
    const defaultOpenConfig = {
        config: {
            subject: "subject",
            type: "CONTEXTUAL_FEEDBACK_SUBMISSION"
        },
        selectedTab: "feedback"
    };
    const helpCenterInstance = {
        close: ()=>messenger.send($lg0Zk.Events.OPEN_HELP_CENTER),
        open: (openConfig = defaultOpenConfig)=>messenger.send($lg0Zk.Events.OPEN_HELP_CENTER, openConfig),
        setButton: (buttonConfig)=>{
            let customButtons = configManager.get("customButtons") || [];
            const buttons = $dd3331e3f91ca419$var$getButtons(buttonConfig); // Reset customButtons
            if (!buttonConfig || buttons.length === 0) {
                customButtons = customButtons.filter((button)=>scopes.indexOf(button.scope) === -1);
                configManager.set({
                    customButtons: customButtons
                });
                messenger.setCallback($lg0Zk.Events.CUSTOM_HELP_BUTTON_CLICK, null);
                return;
            } // Add buttons
            const callbacks = {};
            buttons.forEach(({ callback: callback, id: id = "create_analytics_support_ticket", label: label, scope: scope })=>{
                customButtons.unshift({
                    id: id,
                    label: label,
                    scope: scope || "helpCenter"
                });
                callback && (callbacks[id] = callback);
            });
            configManager.set({
                customButtons: customButtons
            });
            messenger.setCallback($lg0Zk.Events.CUSTOM_HELP_BUTTON_CLICK, callbacks);
        },
        setButtons: (buttons)=>helpCenterInstance.setButton(buttons),
        setFeedbackConfig: (programs)=>{
            const programArray = Array.isArray(programs) ? programs : [
                programs
            ];
            const programNames = new Set();
            programArray.forEach(({ name: name = "unknown" })=>programNames.add(name)); // Call out if a program configuration is set up with duplicate names so
            // the developer can be warned.
            if (programArray.length > programNames.size) metrics.warn("Using duplicate beta program names makes it harder to uniquely identify feedback.", {
                programs: programs
            });
            messenger.send($lg0Zk.Events.FEEDBACK_CONFIG, programArray);
        },
        submitJiraFeedback: (feedbackConfig)=>messenger.send($lg0Zk.Events.JIRA_SUBMIT, feedbackConfig)
    };
    Object.defineProperty(helpCenterInstance, "config", {
        get: ()=>configManager.get("helpCenter"),
        set: (helpCenterConfig)=>{
            configManager.set({
                helpCenter: helpCenterConfig
            });
        }
    });
    return helpCenterInstance;
};
module.exports.default = $dd3331e3f91ca419$var$_default;

});

parcelRegister("e04Rl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a314d5c694783eb8$var$_AppControllerService = $a314d5c694783eb8$var$_interopRequireDefault((parcelRequire("fAza5")));

var $lg0Zk = parcelRequire("lg0Zk");

var $eYPZ6 = parcelRequire("eYPZ6");
function $a314d5c694783eb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a314d5c694783eb8$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $a314d5c694783eb8$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $a314d5c694783eb8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a314d5c694783eb8$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}


var $a314d5c694783eb8$var$_default = (configureNetwork, { metricsApi: metricsApi, metricsInternal: metricsInternal }, window, engine, messenger)=>{
    let activityMonitor;
    let pollingService;
    const { registerApp: registerApp, verifyMessage: verifyMessage, unregisterApp: unregisterApp } = $a314d5c694783eb8$var$_AppControllerService.default;
    const initPolling = async ()=>{
        if (!activityMonitor) {
            const { createActivityMonitor: createActivityMonitor, createPollingService: createPollingService } = await Promise.resolve().then(function() {
                return (parcelRequire("61GKp"));
            }).then((res)=>$a314d5c694783eb8$var$_interopRequireWildcard(res));
            activityMonitor = createActivityMonitor(window);
            pollingService = createPollingService(activityMonitor, metricsApi, window);
        }
    };
    const addPoller = async (poller)=>{
        await initPolling();
        return pollingService.addPoller(poller);
    };
    const configurePolling = async (config)=>{
        await initPolling();
        pollingService.configure(config);
        activityMonitor.configure(config);
    };
    const removePoller = async (handle)=>{
        await initPolling();
        pollingService.removePoller(handle);
    };
    const registerActivityEmitter = async (emitter)=>{
        await initPolling();
        activityMonitor.registerActivityEmitter(emitter);
    };
    const getActivityMonitor = async ()=>{
        await initPolling();
        return activityMonitor;
    };
    const waitForGainsight = async ()=>{
        if (!engine || !messenger) throw new Error("API only runs in an iframe");
        return (0, $eYPZ6.sendAndReceive)($lg0Zk.Events.GAINSIGHT_INIT, messenger).then(()=>engine.configurePromise);
    };
    return {
        addPoller: addPoller,
        configureNetwork: configureNetwork,
        configurePolling: configurePolling,
        getActivityMonitor: getActivityMonitor,
        preloadEngine: ()=>Promise.resolve().then(function() {
                return (parcelRequire("hwTLm"));
            }).then((res)=>$a314d5c694783eb8$var$_interopRequireWildcard(res)),
        registerActivityEmitter: registerActivityEmitter,
        registerApp: registerApp,
        removePoller: removePoller,
        unregisterApp: unregisterApp,
        verifyMessage: verifyMessage,
        waitForConfigure: ()=>engine?.configurePromise,
        waitForGainsight: waitForGainsight,
        ...metricsInternal
    };
};
module.exports.default = $a314d5c694783eb8$var$_default;

});
parcelRegister("fAza5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5957e35beda6a80$var$_stringHash = $b5957e35beda6a80$var$_interopRequireDefault((parcelRequire("mZpaF")));
function $b5957e35beda6a80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5957e35beda6a80$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $b5957e35beda6a80$var$AppControllerService {
    constructor(){
        $b5957e35beda6a80$var$_defineProperty(this, "appToSandboxMap", {});
        $b5957e35beda6a80$var$_defineProperty(this, "appData", {});
        $b5957e35beda6a80$var$_defineProperty(this, "registerApp", (sandboxId, sandboxAppData)=>{
            const { appId: appId } = sandboxAppData;
            const prevSandboxId = this.appToSandboxMap[appId];
            let { nonce: nonce = "" } = this.appData[sandboxId] || {};
            if (!nonce) nonce = btoa((0, $b5957e35beda6a80$var$_stringHash.default)(`${sandboxId}-${performance.now()}-${Math.random()}`).toString());
            this.appToSandboxMap[appId] = sandboxId;
            this.appData[sandboxId] = {
                nonce: nonce,
                ...sandboxAppData
            };
            if (prevSandboxId && prevSandboxId !== sandboxId) delete this.appData[prevSandboxId];
        });
        $b5957e35beda6a80$var$_defineProperty(this, "unregisterApp", (sandboxId)=>{
            delete this.appData[sandboxId];
            Object.entries(this.appToSandboxMap).forEach(([appId, mappedSandboxId])=>{
                sandboxId === mappedSandboxId && delete this.appToSandboxMap[appId];
            });
        });
        $b5957e35beda6a80$var$_defineProperty(this, "verifyMessage", (data, sandboxId)=>!!data?.nonce && this.appData[sandboxId]?.nonce === data.nonce);
        $b5957e35beda6a80$var$_defineProperty(this, "getSandboxId", (appId)=>this.appToSandboxMap[appId]);
    }
    sendMessage(sandboxId, message, origin, postMessageFn) {
        const { nonce: nonce } = this.appData[sandboxId] || {};
        nonce && postMessageFn({
            nonce: nonce,
            ...message
        }, origin);
    }
}
var $b5957e35beda6a80$var$_default = new $b5957e35beda6a80$var$AppControllerService();
module.exports.default = $b5957e35beda6a80$var$_default;

});
parcelRegister("mZpaF", function(module, exports) {
"use strict";
function $0451aff0770abd57$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
module.exports = $0451aff0770abd57$var$hash;

});


parcelRegister("eYPZ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isShell = $ae7efe4f8d3b2c76$var$isShell;
module.exports.getSPAVersion = $ae7efe4f8d3b2c76$var$getSPAVersion;
module.exports.addVersionToMetricsConfig = $ae7efe4f8d3b2c76$var$addVersionToMetricsConfig;
module.exports.generateShellUrl = $ae7efe4f8d3b2c76$var$generateShellUrl;
module.exports.sendAndReceive = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Checks if current window is Unified Shell or iframe.
 * @returns true if running in Shell, false if running in an iframe
 */ function $ae7efe4f8d3b2c76$var$isShell(window) {
    const { config: config, navigator: { userAgent: userAgent, webdriver: webdriver }, parent: parent } = window;
    return parent === window && !(webdriver || userAgent.toLowerCase().includes(" electron/")) || config?.tis === 1;
}
function $ae7efe4f8d3b2c76$var$getSPAVersion(window) {
    if (window.config?.spaVersion) return window.config.spaVersion;
    if (window.location.origin.includes("localhost")) return "local";
}
function $ae7efe4f8d3b2c76$var$addVersionToMetricsConfig(config, window) {
    const version = $ae7efe4f8d3b2c76$var$getSPAVersion(window);
    return version && config.application ? {
        ...config,
        application: {
            ...config.application,
            version: version
        }
    } : config;
}
function $ae7efe4f8d3b2c76$var$splitPath(path, separator) {
    const startsWithSlash = path.startsWith("/");
    const idx = path.indexOf(separator);
    const res = idx > -1 ? path.slice(idx + separator.length) : path;
    return res.startsWith("/") || !startsWithSlash ? res : `/${res}`;
}
const $ae7efe4f8d3b2c76$var$AEM_DOMAIN = /^https:\/\/author-p\d{4,10}-e\d{4,10}(-cmstg)?.adobeaemcloud.com/; // Only capture urls without solutions as first path parameter. For these cases
// this isnt a shell URL -- it is a frame src of an app on SPA Pipeline that does
// not use the CDN yet.
const $ae7efe4f8d3b2c76$var$SHELL_URL_REGEX = [
    /^https:\/\/experience(-qa|-stage)?.adobe.com(?!\/solutions)/,
    new RegExp(`${$ae7efe4f8d3b2c76$var$AEM_DOMAIN.source}/ui`)
];
const $ae7efe4f8d3b2c76$var$returnShellUrl = (locationHref, externalQueryParams)=>{
    const windowUrl = new URL(locationHref);
    if (externalQueryParams) {
        const search = new URLSearchParams(externalQueryParams);
        search.forEach((value, param)=>windowUrl.searchParams.set(param, value));
    }
    return windowUrl.toString();
};
const $ae7efe4f8d3b2c76$var$generateHashForPath = (baseUrl, org, sandbox, subOrg)=>{
    // Split baseUrl.hash by tenant and solution path to insert sandbox.
    const { hash: hash } = baseUrl;
    const [, tenant, _sandbox, _subOrg, solutionPath] = hash.match(`^#(/@[^/]*)?(/sname:[^/]+)?(/so:[^/]+)?(/[^$]+)`) || [];
    /**
   * Get the active sandbox or subOrg in the order defined by `items`. It finds
   * the first defined value and returns the built string for it.
   */ const getActive = (items)=>{
        const [prefix, item] = items.find(([, val])=>val) || []; // No defined item was found, return empty string.
        if (!item) return "";
         // The regex pulls off the entire prefix + value string, so only build the
        // string if it's not from the regex.
        return item.startsWith(`/${prefix}`) ? item : `/${prefix}:${item}`;
    }; // Order in which to check the sandbox and sub-org values. Should always use
    // the ones defined by the user first, then fall back to the ones that exist
    // on the hash already.
    const sandboxSubOrgOrder = [
        [
            "sname",
            sandbox
        ],
        [
            "so",
            subOrg
        ],
        [
            "sname",
            _sandbox
        ],
        [
            "so",
            _subOrg
        ]
    ]; // If org is set, only add new sandbox or sub-org (1st 2 items in the array)
    // as each org has different values and we shouldn't inherit the pre-existing
    // ones. If the org is not being set, keep the same tenant but use the first
    // new then existing sandbox or sub-org that is defined.
    return org ? `#/@${org}${getActive(sandboxSubOrgOrder.slice(0, 2))}${solutionPath}` : `#${tenant || ""}${getActive(sandboxSubOrgOrder)}${solutionPath}`;
};
const $ae7efe4f8d3b2c76$var$generateNewAppPath = (shellUrl, locationPath, tenant, externalQueryParams, sandbox)=>{
    shellUrl.hash = sandbox ? `${tenant}/sname:${sandbox}${locationPath}` : `${tenant}${locationPath}`;
    shellUrl.search = externalQueryParams;
    return shellUrl.toString();
};
/**
 * Called when receiving a message from the parent frame.
 * @param config The current external configuration.
 * @param location A ShellUrlObject to describe the location lookup.
 * @param newApp true if the URL is for a new application window.
 * @returns A valid full shell URL (as a string).
 */ function $ae7efe4f8d3b2c76$var$generateShellUrl(config, location, newApp) {
    let locationHref = location.href || "";
    const { baseFrameUrl: baseFrameUrl, discovery: discovery, externalQueryParams: externalQueryParams, historyType: historyType } = config;
    const baseUrl = new URL(config.baseUrl);
    const isHashHistory = historyType === "HASH";
    const configUrl = new URL(baseFrameUrl);
    const shellUrl = new URL(baseUrl.origin);
    const { org: org, path: path, sandbox: sandbox, subOrg: subOrg } = location; // If the href is already a shell URL, there is nothing more to do.
    if ($ae7efe4f8d3b2c76$var$SHELL_URL_REGEX.some((regex)=>regex.test(locationHref))) return $ae7efe4f8d3b2c76$var$returnShellUrl(locationHref, externalQueryParams);
     // The AEM domain has a path where the standard experience.adobe does not.
    // Add the path for the AEM variation.
    if ($ae7efe4f8d3b2c76$var$AEM_DOMAIN.test(shellUrl.origin)) shellUrl.pathname = "/ui";
    if (!locationHref) {
        // Solutions URLs are "mounted" at the URL provided by the solution config
        // or by the discovery endpoint. The `baseFrameUrl` is the root URL that is
        // mounted at the `/@tenant/solution` path. If `baseFrameUrl` came from a
        // discovery call, it will be a fully formed path to a page with their
        // application. We can't just append the new path to that URL and instead
        // must treat the path as an absolute path (e.g. completely replacing the
        // existing path). In the non-discovery case, the `baseFrameUrl` is a
        // non-fully formed path within the application (e.g. /solutions/ddam). Any
        // new path should be appended to the `baseFrameUrl`'s path.
        const base = discovery ? configUrl.origin : baseFrameUrl;
        let locationPath = path || ""; // Instead of updating the current shellUrl, newApp generates a shellUrl
        // for use in opening a window or tab for another solution with the provided
        // path while maintaining the query parameters present in the current url.
        if (newApp) return $ae7efe4f8d3b2c76$var$generateNewAppPath(shellUrl, locationPath, `/@${config.tenant}`, externalQueryParams, sandbox);
        locationPath = isHashHistory && locationPath.indexOf("#") === -1 ? `/#${locationPath}` : locationPath || "/";
        locationHref = `${base}${locationPath}`;
    }
    const url = new URL(locationHref);
    const removeParams = [
        ...config.browserParamFilterList || [],
        ...Array.from($lg0Zk.BROWSER_FILTER_PARAMS)
    ];
    removeParams.forEach((param)=>url.searchParams.has(param) && url.searchParams.delete(param));
    const hash = $ae7efe4f8d3b2c76$var$generateHashForPath(baseUrl, org, sandbox, subOrg);
    let pathname = isHashHistory ? url.hash.replace(/^#\//, "/") : url.pathname;
    pathname = `${hash}${discovery ? pathname : $ae7efe4f8d3b2c76$var$splitPath(pathname, configUrl.pathname)}`; // Need to preserve the search and hash values on the URL being loaded.
    shellUrl.hash = `${pathname}${url.search}${isHashHistory ? "" : url.hash}`;
    shellUrl.search = externalQueryParams;
    return shellUrl.toString();
}
const $ae7efe4f8d3b2c76$var$sendAndReceive = (eventOut, messenger, value, eventIn = eventOut)=>{
    messenger.send(eventOut, value);
    return new Promise((res, rej)=>messenger.setCallback(eventIn, (data)=>{
            data != null && typeof data === "object" && "rejected" in data && "error" in data ? rej(new Error(data.error)) : res(data);
        }));
};
module.exports.sendAndReceive = $ae7efe4f8d3b2c76$var$sendAndReceive;

});

parcelRegister("61GKp", function(module, exports) {


module.exports = (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("Pc7wl")).then(()=>parcelRequire("l8pe2"));

});


parcelRegister("11Bzf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.initMetrics = module.exports.writeWithVersion = module.exports.userOptOut = void 0;

var $0bf30696a92aac4f$var$_lazyMetrics = $0bf30696a92aac4f$var$_interopRequireDefault((parcelRequire("5SDA5")));

var $0bf30696a92aac4f$var$_v = $0bf30696a92aac4f$var$_interopRequireDefault((parcelRequire("dd4La")));
function $0bf30696a92aac4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bf30696a92aac4f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0bf30696a92aac4f$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $0bf30696a92aac4f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0bf30696a92aac4f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $0bf30696a92aac4f$var$metricsRuntimePromise = Promise.resolve().then(function() {
    return (parcelRequire("55hum"));
}).then((res)=>$0bf30696a92aac4f$var$_interopRequireWildcard(res)).then(({ MetricsRuntime: MetricsRuntime })=>MetricsRuntime);
const $0bf30696a92aac4f$var$userOptOut = (optOut, { adobeMetrics: adobeMetrics })=>adobeMetrics.optOut(optOut);
module.exports.userOptOut = $0bf30696a92aac4f$var$userOptOut;
const $0bf30696a92aac4f$var$writeWithVersion = async (record, { adobeMetrics: adobeMetrics })=>{
    const { sdkVersion: sdkVersion } = adobeMetrics;
    record.metricsState = Object.assign(record.metricsState || {}, {
        sdkVersion: sdkVersion
    });
    if (record.metricsState.correlationId === "uuid") record.metricsState.correlationId = (0, $0bf30696a92aac4f$var$_v.default)();
    return adobeMetrics.write(record);
};
module.exports.writeWithVersion = $0bf30696a92aac4f$var$writeWithVersion;
const $0bf30696a92aac4f$var$initMetrics = (optOut, write, win)=>{
    if (!win.adobeMetrics) win.adobeMetrics = {
        optOut: optOut,
        write: write
    };
};
module.exports.initMetrics = $0bf30696a92aac4f$var$initMetrics;
const $0bf30696a92aac4f$var$configureMetrics = (lazyWrite, onConfigure, win, config)=>$0bf30696a92aac4f$var$metricsRuntimePromise.then((MetricsRuntime)=>{
        const { adobeMetrics: adobeMetrics } = win;
        if (adobeMetrics.write === lazyWrite) {
            delete adobeMetrics.optOut;
            delete adobeMetrics.write;
            delete adobeMetrics.configure;
        }
        return MetricsRuntime.configure(config, win);
    }).then((returnedConfig)=>{
        config && onConfigure();
        return returnedConfig;
    });
var $0bf30696a92aac4f$var$_default = (win)=>{
    let filter;
    let pendingOptOut;
    let queue = [];
    let ready = false;
    let readyResolve;
    let toFlush = false;
    const readyPromise = new Promise((resolve)=>readyResolve = resolve);
    const onConfigure = ()=>{
        if (!ready) {
            readyResolve();
            if (pendingOptOut !== undefined) {
                $0bf30696a92aac4f$var$userOptOut(pendingOptOut, win);
                pendingOptOut = undefined;
            }
            queue.forEach((record)=>$0bf30696a92aac4f$var$writeWithVersion(record, win));
            queue = [];
            toFlush && win.adobeMetrics.flush();
            ready = true;
        }
    };
    const lazyOptOut = (optOut)=>{
        if (ready) return win.adobeMetrics.optOut(optOut);
        pendingOptOut = optOut;
    };
    const lazyWrite = async (record)=>{
        const _record = filter ? await filter(record) : record;
        if (ready) return $0bf30696a92aac4f$var$writeWithVersion(_record, win);
        queue.push(_record);
        return 0;
    };
    $0bf30696a92aac4f$var$initMetrics(lazyOptOut, lazyWrite, win);
    async function executeOnReady(action) {
        ready || await readyPromise;
        action();
    }
    return {
        metricsApi: {
            create: (name, ...args)=>new $0bf30696a92aac4f$var$_lazyMetrics.default(lazyWrite, win, name, ...args)
        },
        metricsInternal: {
            clearUser: (version)=>executeOnReady(()=>win.adobeMetrics.clearUser(version)),
            configureMetrics: (config)=>$0bf30696a92aac4f$var$configureMetrics(lazyWrite, onConfigure, win, config),
            flush: async ()=>{
                if (ready) return win.adobeMetrics.flush();
                toFlush = true;
                return 0;
            },
            setApplication: (app)=>executeOnReady(()=>win.adobeMetrics.setApplication(app)),
            setFilter: (filterFunction)=>filter = filterFunction,
            setUser: (user, version)=>executeOnReady(()=>win.adobeMetrics.setUser(user, version))
        },
        write: lazyWrite
    };
};
module.exports.default = $0bf30696a92aac4f$var$_default;

});
parcelRegister("5SDA5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.OMEGA_TIMEOUT_MS = void 0;

var $f9A5f = parcelRequire("f9A5f");

var $i6Tec = parcelRequire("i6Tec");

var $lg0Zk = parcelRequire("lg0Zk");
function $4480b2dd6b1e2f47$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $4480b2dd6b1e2f47$var$OMEGA_TIMEOUT_MS = 5000;
module.exports.OMEGA_TIMEOUT_MS = $4480b2dd6b1e2f47$var$OMEGA_TIMEOUT_MS;
class $4480b2dd6b1e2f47$var$MetricsTimer {
    constructor(write, nowFn, name, context, prefix, ...args){
        $4480b2dd6b1e2f47$var$_defineProperty(this, "epoch", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "now", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "prefix", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "name", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "context", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "write", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "nowFn", void 0);
        this.nowFn = nowFn;
        this.epoch = nowFn();
        this.now = nowFn();
        this.context = context;
        this.name = name;
        this.prefix = prefix;
        this.write = write;
        this.time("start", ...args);
    }
    time(eventName, ...args) {
        let event; // calculate new event
        if (eventName && typeof eventName === "object") event = eventName.event;
        else event = (this.prefix || "") + (this.prefix && eventName ? "." : "") + (eventName || "");
        const _now = this.nowFn();
        const duration = _now - this.epoch;
        const record = {
            data: args.length > 0 ? [
                ...args
            ] : undefined,
            dateNow: Date.now(),
            duration: duration,
            epoch: this.epoch,
            event: event,
            level: $f9A5f.Level.INFO,
            metricsState: {
                context: this.context,
                correlationId: "uuid"
            },
            name: this.name,
            now: _now,
            prefix: this.prefix,
            recordType: $i6Tec.RecordType.TIMER
        };
        this.write(record);
        return duration;
    }
}
class $4480b2dd6b1e2f47$var$LazyMetrics {
    constructor(write, win, name, ..._args){
        $4480b2dd6b1e2f47$var$_defineProperty(this, "context", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "name", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "write", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "getAdobeMetrics", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "verbose", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "waitForOmega", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "nowFn", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "omegaPromise", void 0);
        $4480b2dd6b1e2f47$var$_defineProperty(this, "history", {
            back: (...args)=>this._historyLog("back", args),
            forward: (...args)=>this._historyLog("forward", args),
            go: (n, ...args)=>{
                args.unshift({
                    n: n
                });
                return this._historyLog("go", args);
            },
            push: (path, state, ...args)=>{
                args.unshift({
                    path: path,
                    state: state
                });
                return this._historyLog("push", args);
            },
            replace: (path, state, ...args)=>{
                args.unshift({
                    path: path,
                    state: state
                });
                return this._historyLog("replace", args);
            }
        });
        $4480b2dd6b1e2f47$var$_defineProperty(this, "analytics", {
            track: (type, ...args)=>this.waitForOmega().then(()=>this._trackLog(type, args)),
            trackEvent: (eventData, ...args)=>{
                args.unshift(eventData);
                return this.waitForOmega().then(()=>this._trackLog("Event", args));
            },
            trackPage: (pageData, ...args)=>{
                args.unshift(pageData);
                return this.waitForOmega().then(()=>this._trackLog("Page", args));
            },
            trackUser: (userData, ...args)=>{
                args.unshift(userData);
                return this.waitForOmega().then(()=>this._trackLog("User", args));
            }
        });
        $4480b2dd6b1e2f47$var$_defineProperty(this, "location", {
            /**
       * Record a location assign event.
       * @param {string} url A string for the window location path being assigned.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */ assign: (url, ...props)=>{
                props.unshift({
                    url: url
                });
                return this._log($i6Tec.RecordType.LOCATION, $f9A5f.Level.INFO, this.name, undefined, "assign", undefined, props);
            },
            /**
       * Record a location reload event.
       * @param {boolean} force A boolean to indicate that the page was or will be
       * reloaded from the server.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */ reload: (force, ...props)=>{
                props.unshift({
                    force: force
                });
                return this._log($i6Tec.RecordType.LOCATION, $f9A5f.Level.INFO, this.name, undefined, "reload", undefined, props);
            },
            /**
       * Record a location replace event.
       * @param {string} url A string for the window location path being assigned.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */ replace: (url, ...props)=>{
                props.unshift({
                    url: url
                });
                return this._log($i6Tec.RecordType.LOCATION, $f9A5f.Level.INFO, this.name, undefined, "replace", undefined, props);
            }
        });
        const { location: location, performance: { now: now } } = win;
        this.verbose = location.search.includes("shell_verbose=true");
        this.nowFn = now.bind(win.performance);
        this.getAdobeMetrics = ()=>win.adobeMetrics;
        this.write = write;
        this.name = name;
        _args.length && (this.context = _args[0]);
        const waitForOmegaInit = async ()=>{
            if (win._satellite) return true;
            return new Promise((resolve)=>win.addEventListener("init_omega", ()=>resolve(true)));
        };
        this.waitForOmega = ()=>{
            if (!this.omegaPromise) this.omegaPromise = (0, $lg0Zk.runWithTimeout)(waitForOmegaInit(), $4480b2dd6b1e2f47$var$OMEGA_TIMEOUT_MS, false, win);
            return this.omegaPromise;
        };
    }
    start(prefix, ...args) {
        return new $4480b2dd6b1e2f47$var$MetricsTimer(this.write, this.nowFn, this.name, this.context, prefix, ...args);
    }
    _log(recordType, level, name, message, event, dateNow, args) {
        if (this.verbose && args?.length) {
            const levelOverride = args.find((data)=>typeof data === "object" && [
                    "DEBUG",
                    "ERROR",
                    "WARN"
                ].includes(data?.level) && Object.keys(data).length === 1);
            levelOverride && (level = levelOverride.level);
        }
        return this.write({
            data: args.length > 0 ? [
                ...args
            ] : undefined,
            dateNow: dateNow || Date.now(),
            event: event,
            level: level,
            message: message,
            name: name,
            recordType: recordType
        });
    }
    _historyLog(event, args) {
        return this._log($i6Tec.RecordType.HISTORY, $f9A5f.Level.INFO, this.name, undefined, event, undefined, args);
    }
    _trackLog(type, args) {
        return this._log($i6Tec.RecordType.ANALYTICS, $f9A5f.Level.INFO, this.name, undefined, type, undefined, args);
    }
    /**
   * Queue a record for transmission to remote storage.
   * @param {Record} record - The object to be stored.
   */ store(record) {
        record.name = this.name;
        this.write(record);
    }
    /**
   * Log an ERROR message to remote storage, with an optional
   * data payload; emulates console.error().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ error(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.ERROR, this.name, message, undefined, undefined, args);
    }
    /**
   * Log a WARN message to remote storage, with an optional data payload;
   * emulates console.warn().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ warn(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.WARN, this.name, message, undefined, undefined, args);
    }
    /**
   * Log an INFO message to remote storage, with an optional data payload;
   * emulates console.log().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ info(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.INFO, this.name, message, undefined, undefined, args);
    }
    /**
   * Log an INFO message to remote storage, with an optional data payload;
   * emulates console.info().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ log(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.INFO, this.name, message, undefined, undefined, args);
    }
    /**
   * Log a DEBUG message to remote storage, with an optional data payload;
   * emulates console.debug().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ debug(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.DEBUG, this.name, message, undefined, undefined, args);
    }
    /**
   * Log a TRACE message to remote storage, with an optional data payload;
   * emulates console.trace().
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ trace(message, ...args) {
        return this._log($i6Tec.RecordType.LOG, $f9A5f.Level.TRACE, this.name, message, undefined, undefined, args);
    }
    /**
   * Construct a named event and emit it to storage, along with an optional
   * data payload. Event level will default to INFO. To specify a different
   * level, add an level object to the args parameters in the form
   * {level: Level.DEBUG}.
   * @function
   * @param {string} event The event.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ event(event, ...args) {
        return this._log($i6Tec.RecordType.EVENT, $f9A5f.Level.INFO, this.name, undefined, event, undefined, args);
    }
    /**
   * Construct a named "Recent" event and emit it to storage. The payload is expected
   * to contain PII so downstream handling must a) keep the data bag intact, and
   * b) send the Recent record (with PII) only to Unified Recents. PII must be
   * removed before sending to ADX.
   * @function
   * @param {string} recent The event.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */ recent(recent, ...args) {
        const { onRecents: onRecents } = this.getAdobeMetrics();
        onRecents && onRecents(recent, args);
        return this._log($i6Tec.RecordType.RECENT, $f9A5f.Level.INFO, this.name, undefined, recent, undefined, args);
    }
}
module.exports.default = $4480b2dd6b1e2f47$var$LazyMetrics;

});
parcelRegister("f9A5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Level = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Log levels, for RecordType == Log.
 */ /**
 * @ignore
 */ let $cdac958d874b0fff$var$Level;
module.exports.Level = $cdac958d874b0fff$var$Level;
(function(Level) {
    Level["ERROR"] = "ERROR";
    Level["WARN"] = "WARN";
    Level["INFO"] = "INFO";
    Level["DEBUG"] = "DEBUG";
    Level["TRACE"] = "TRACE";
})($cdac958d874b0fff$var$Level || (module.exports.Level = $cdac958d874b0fff$var$Level = {}));

});

parcelRegister("i6Tec", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecordType = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * RecordType is an enumeration of known telemetry records. These
 * record types have specified symantics and use specific columns
 * for each type. That said, any record type may specify any of the
 * known fields for the custom purpose of the application.
 *
 * All RecordTypes except User are implementations of the Metric
 * interface. The User RecordType is for User context changes and should
 * not be created direclty by clients.
 *
 * Clients may specify custom record types, however there will be no
 * attempt to validate any fields. Storage of custom record types may
 * silently fail.
 */ let $e1f12ace46c1fb44$var$RecordType;
module.exports.RecordType = $e1f12ace46c1fb44$var$RecordType;
(function(RecordType) {
    RecordType["ANALYTICS"] = "Analytics";
    RecordType["EVENT"] = "Event";
    RecordType["RECENT"] = "Recent";
    RecordType["HISTORY"] = "History";
    RecordType["LOCATION"] = "Location";
    RecordType["LOG"] = "Log";
    RecordType["NETWORK_REQUEST"] = "NetworkRequest";
    RecordType["NETWORK_RESPONSE"] = "NetworkResponse";
    RecordType["RESOURCE_TIMING"] = "ResourceTiming";
    RecordType["PAINT_TIMING"] = "PaintTiming";
    RecordType["NAVIGATION_TIMING"] = "NavigationTiming";
    RecordType["TIMER"] = "Timer";
    RecordType["TRACER"] = "Tracer";
    RecordType["USER"] = "User";
})($e1f12ace46c1fb44$var$RecordType || (module.exports.RecordType = $e1f12ace46c1fb44$var$RecordType = {}));

});


parcelRegister("dd4La", function(module, exports) {

var $83XaQ = parcelRequire("83XaQ");

var $75lAJ = parcelRequire("75lAJ");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $99e02e6fbb954cf0$var$_nodeId;
var $99e02e6fbb954cf0$var$_clockseq;
// Previous uuid creation time
var $99e02e6fbb954cf0$var$_lastMSecs = 0;
var $99e02e6fbb954cf0$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $99e02e6fbb954cf0$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $99e02e6fbb954cf0$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $99e02e6fbb954cf0$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $83XaQ();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $99e02e6fbb954cf0$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $99e02e6fbb954cf0$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $99e02e6fbb954cf0$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $99e02e6fbb954cf0$var$_lastMSecs + (nsecs - $99e02e6fbb954cf0$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $99e02e6fbb954cf0$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $99e02e6fbb954cf0$var$_lastMSecs = msecs;
    $99e02e6fbb954cf0$var$_lastNSecs = nsecs;
    $99e02e6fbb954cf0$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $75lAJ(b);
}
module.exports = $99e02e6fbb954cf0$var$v1;

});
parcelRegister("83XaQ", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $5dec813b1c1d17db$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($5dec813b1c1d17db$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $5dec813b1c1d17db$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $5dec813b1c1d17db$var$getRandomValues($5dec813b1c1d17db$var$rnds8);
        return $5dec813b1c1d17db$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $5dec813b1c1d17db$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $5dec813b1c1d17db$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $5dec813b1c1d17db$var$rnds;
    };
}

});

parcelRegister("75lAJ", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5289bfa7fb79ecd9$var$byteToHex = [];
for(var $5289bfa7fb79ecd9$var$i = 0; $5289bfa7fb79ecd9$var$i < 256; ++$5289bfa7fb79ecd9$var$i)$5289bfa7fb79ecd9$var$byteToHex[$5289bfa7fb79ecd9$var$i] = ($5289bfa7fb79ecd9$var$i + 0x100).toString(16).substr(1);
function $5289bfa7fb79ecd9$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $5289bfa7fb79ecd9$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $5289bfa7fb79ecd9$var$bytesToUuid;

});


parcelRegister("55hum", function(module, exports) {


module.exports = (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("irvOl")).then(()=>parcelRequire("3Cnuf"));

});


parcelRegister("lhEz4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7eaa6cf4335b08b$var$_fetch = $f7eaa6cf4335b08b$var$_interopRequireDefault((parcelRequire("cJ3kn")));

var $f7eaa6cf4335b08b$var$_graphql = $f7eaa6cf4335b08b$var$_interopRequireDefault((parcelRequire("io0Nk")));

var $lg0Zk = parcelRequire("lg0Zk");
function $f7eaa6cf4335b08b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7eaa6cf4335b08b$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $f7eaa6cf4335b08b$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $f7eaa6cf4335b08b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f7eaa6cf4335b08b$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}


var $f7eaa6cf4335b08b$var$_default = (metrics, win, engine, messenger)=>{
    const fetchApi = (0, $f7eaa6cf4335b08b$var$_fetch.default)(metrics, win, messenger);
    const graphql = (0, $f7eaa6cf4335b08b$var$_graphql.default)(fetchApi.fetch, metrics, win);
    const configureNetwork = (config)=>{
        fetchApi.configure(config);
        graphql.configure(config);
    };
    return {
        configureNetwork: configureNetwork,
        network: {
            createApolloClient: async (apolloClientProvided, options)=>(await Promise.resolve().then(function() {
                    return (parcelRequire("fQPSB"));
                }).then((res)=>$f7eaa6cf4335b08b$var$_interopRequireWildcard(res))).createCustomApolloClient(graphql.baseQuery, options, apolloClientProvided),
            fetch: fetchApi.fetch,
            getApolloClient: async (options)=>{
                messenger?.send($lg0Zk.Events.DEPRECATION_WARNING, "getApolloClient");
                return (await Promise.resolve().then(function() {
                    return (parcelRequire("fQPSB"));
                }).then((res)=>$f7eaa6cf4335b08b$var$_interopRequireWildcard(res))).getApolloClient(graphql.baseQuery, options);
            },
            getPrefetched: (key, options)=>{
                if (!engine) throw new Error("API only runs in an iframe");
                return engine.modules.networkPrefetch().prefetch(key, options);
            },
            query: graphql.query
        }
    };
};
module.exports.default = $f7eaa6cf4335b08b$var$_default;

});
parcelRegister("cJ3kn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5BWqp = parcelRequire("5BWqp");

var $943c44cb44910623$var$_invalidStatusCodeError = $943c44cb44910623$var$_interopRequireDefault((parcelRequire("461Ry")));

var $fBGTm = parcelRequire("fBGTm");

var $8WsMI = parcelRequire("8WsMI");

var $943c44cb44910623$var$_v = $943c44cb44910623$var$_interopRequireDefault((parcelRequire("dd4La")));
function $943c44cb44910623$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $943c44cb44910623$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $943c44cb44910623$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $943c44cb44910623$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $943c44cb44910623$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $943c44cb44910623$var$setAuth(init, metadata) {
    init.headers.set("Authorization", `Bearer ${metadata.token}`); // imsClientId is the backcompat property that allowed users to override the
    // api key header. This needs to stay as the prioritized property to allow
    // existing implementations to work correct. apiKey is the new property, which
    // is also set by default from Unified Shell, but can be overridden by users
    // also in the same way.
    const apiKey = metadata.imsClientId || metadata.apiKey;
    apiKey && init.headers.set("x-api-key", apiKey);
}
function $943c44cb44910623$var$setImsOrg(init, metadata) {
    $943c44cb44910623$var$setAuth(init, metadata);
    metadata.imsOrg && init.headers.set("x-gw-ims-org-id", metadata.imsOrg);
}
function $943c44cb44910623$var$setSandbox(init, metadata) {
    $943c44cb44910623$var$setImsOrg(init, metadata);
    if (init.auth === "Header") metadata.sandbox && init.headers.set("x-sandbox-name", metadata.sandbox.name);
}
function $943c44cb44910623$var$setSandboxPlus(init, metadata) {
    $943c44cb44910623$var$setSandbox(init, metadata);
    if (init.auth === "Header") {
        metadata.sandbox && init.headers.set("x-sandbox-type", metadata.sandbox.type);
        metadata.sandbox && init.headers.set("x-sandbox-default", metadata.sandbox.isDefault.toString());
    }
}
function $943c44cb44910623$var$addHeadersBasedOnScope(init, metadata) {
    switch(init.scope){
        case $5BWqp.FetchScope.AUTH:
            $943c44cb44910623$var$setAuth(init, metadata);
            return;
        case $5BWqp.FetchScope.ORG:
            $943c44cb44910623$var$setImsOrg(init, metadata);
            return;
        case $5BWqp.FetchScope.SANDBOX:
            $943c44cb44910623$var$setSandbox(init, metadata);
            return;
        case $5BWqp.FetchScope.SANDBOX_PLUS:
            $943c44cb44910623$var$setSandboxPlus(init, metadata);
            return;
        case $5BWqp.FetchScope.NONE:
        default:
            return;
    }
}
function $943c44cb44910623$var$updateReq({ apiKey: apiKey, imsOrg: imsOrg, imsToken: token, sandbox: sandbox }, init) {
    const metadata = {
        apiKey: apiKey,
        imsOrg: imsOrg,
        sandbox: sandbox,
        token: token,
        ...init.metadata
    };
    if (!(init.headers instanceof Headers)) init.headers = new Headers(init.headers);
    init.scope = init.scope || $5BWqp.FetchScope.SANDBOX_PLUS;
    if (!metadata.token) throw new Error("Fetch Api called without token");
    $943c44cb44910623$var$addHeadersBasedOnScope(init, metadata);
    init.requestId && init.headers.set("x-request-id", init.requestId === "auto" ? (0, $943c44cb44910623$var$_v.default)() : init.requestId);
    if (init.auth === "Body") {
        const params = {};
        const { sandbox: metaDataSandbox } = metadata;
        if (metaDataSandbox && [
            $5BWqp.FetchScope.SANDBOX_PLUS,
            $5BWqp.FetchScope.SANDBOX
        ].includes(init.scope)) {
            params.sandboxName = metaDataSandbox.name;
            if (init.scope === $5BWqp.FetchScope.SANDBOX_PLUS) {
                params.sandboxType = metaDataSandbox.type;
                params.isDefaultSandbox = metaDataSandbox.isDefault.toString();
            }
        }
        if (!init.body) init.body = JSON.stringify(params);
        else {
            const parsedBody = JSON.parse(init.body);
            Object.assign(parsedBody, params);
            init.body = JSON.stringify(parsedBody);
        }
    }
    return init;
}

const $943c44cb44910623$var$executeFetch = async ({ logger: logger, fetchConfig: fetchConfig, win: win, saFetch: saFetch, input: input, init: init, messenger: messenger, ioEndpoint: ioEndpoint, ioRegionSpecificMap: ioRegionSpecificMap })=>{
    //populate network-runtime option to differentiate network runtime fetch.
    const startTimestamp = Date.now();
    let fetchInput = input;
    try {
        if (ioRegionSpecificMap && fetchConfig.sandbox && fetchConfig.sandbox.region && ioRegionSpecificMap[fetchConfig.sandbox.region.toLowerCase()]) {
            let ioRegionSpecificEndpoint = ioRegionSpecificMap[fetchConfig.sandbox.region.toLowerCase()];
            ioRegionSpecificEndpoint = `${ioRegionSpecificEndpoint}/graph/graphql?appId=${fetchConfig.appId}`;
            fetchInput = input instanceof Request ? new Request(ioRegionSpecificEndpoint, input) : ioRegionSpecificEndpoint;
        } // Run a slightly modified version of fetch which throws for certain status codes
        // By default throw on 429, 502, etc. - Could be configured for different codes via init.
        return await (0, $8WsMI.statusAwareFetch)(fetchInput, {
            ...init,
            "network-runtime": true
        }, fetchConfig.imsToken, win, logger, messenger);
    } catch (error) {
        // Note: We have disabled the fallback to the ioEndpoint here, and may re-enable
        // after gathering more data.
        const addedInfo = error instanceof $943c44cb44910623$var$_invalidStatusCodeError.default ? ` with status ${error.status}` : "";
        logger.event("Fetch.fallback", `Initial call failed${addedInfo}. Retrying with exponential backoff.`, {
            endpoint: fetchInput instanceof Request ? fetchInput.url : fetchInput,
            ioEndpoint: ioEndpoint
        }, {
            level: $fBGTm.Level.WARN
        }); // Since fetchWithRetry will (hopefully) not be required for most fetches,
        // dynamically import it to save bytes.
        const { fetchWithRetry: fetchWithRetry } = await Promise.resolve().then(function() {
            return (parcelRequire("1GjWl"));
        }).then((res)=>$943c44cb44910623$var$_interopRequireWildcard(res));
        return fetchWithRetry(ioEndpoint || fetchInput, init, error, startTimestamp, saFetch, win, logger);
    }
};
var $943c44cb44910623$var$_default = (metricsApi, win, messenger)=>{
    const logger = metricsApi.create("exc.module-runtime.network.fetch");
    let fetchConfig = {
        apiKey: "",
        appId: "",
        imsOrg: "",
        imsToken: "",
        sandbox: {
            isDefault: true,
            name: "",
            region: "",
            state: "",
            title: "",
            type: ""
        }
    };
    const saFetch = (input, init)=>(0, $8WsMI.statusAwareFetch)(input, init, fetchConfig.imsToken, win, logger, messenger);
    const fetchApi = async (input, fetchInit, ioEndpoint, ioRegionSpecificMap)=>{
        const init = fetchInit && (fetchInit.auth || fetchInit.scope && fetchInit.scope !== $5BWqp.FetchScope.NONE) ? $943c44cb44910623$var$updateReq(fetchConfig, fetchInit) : fetchInit;
        return $943c44cb44910623$var$executeFetch({
            fetchConfig: fetchConfig,
            init: init,
            input: input,
            ioEndpoint: ioEndpoint,
            ioRegionSpecificMap: ioRegionSpecificMap,
            logger: logger,
            messenger: messenger,
            saFetch: saFetch,
            win: win
        }).catch((err)=>{
            if (ioEndpoint) logger.event("Fetch.fallbackFailed", "Failed to call both Primary and Secondary domain", {
                endpoint: input instanceof Request ? input.url : input,
                ioEndpoint: ioEndpoint
            }, {
                level: $fBGTm.Level.ERROR
            });
            if (err instanceof $943c44cb44910623$var$_invalidStatusCodeError.default) throw err;
            throw new Error(`error in making a fetch call. Error is:- ${err}`);
        });
    };
    return {
        configure: (config)=>{
            fetchConfig = {
                ...fetchConfig,
                ...config
            };
        },
        fetch: fetchApi
    };
};
module.exports.default = $943c44cb44910623$var$_default;

});
parcelRegister("5BWqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetch = $0bb5a884626b2eaa$var$fetch;
module.exports.getPrefetched = $0bb5a884626b2eaa$var$getPrefetched;
module.exports.query = $0bb5a884626b2eaa$var$query;
module.exports.getApolloClient = $0bb5a884626b2eaa$var$getApolloClient;
module.exports.createApolloClient = $0bb5a884626b2eaa$var$createApolloClient;
module.exports.FetchScope = module.exports.ROUTING = module.exports.DEFAULT_STATUS_CODES_TO_RETRY = void 0;

var $lcrxv = parcelRequire("lcrxv");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs that simplify code to make authenticated network requests for resources, execute GraphQL
 * queries, etc..
 *
 * ***Import:***
 *
 * ```typescript
 * import {fetch, query} from '@adobe/exc-app/network';
 * ```
 *
 * ***Default export:***
 *
 * [NetworkApi](../interfaces/network.networkapi.md)
 *
 * ***Usage:***
 *
 * ```typescript
 * import {fetch, query} from '@adobe/exc-app/network';
 *
 * // Performs a window.fetch call with Authorization and x-api-key headers set
 * const fetchResponse = await fetch('https://localhost', {auth: 'Header', method: 'GET'});
 *
 * // Executes a query for resources to the ExC GraphQL service
 * const queryResponse = await query({
 *   data: {
 *     query: `
 *       query PPSQuery($userId: String!, $apiKey: String!) {
 *         getPPSProfile(userId: $userId, apiKey: $apiKey) {
 *           images
 *         }
 *       }`,
 *     variables: {
 *       apiKey: 'test-app',
 *       userId: '123@AdobeID'
 *     }
 *   },
 *   operationName: 'PPSAvatar'
 * });
 *
 * ```
 * @packageDocumentation
 * @module network
 */ /**
 * Default status codes which imply a transient error and can be retried.
 */ const $0bb5a884626b2eaa$var$DEFAULT_STATUS_CODES_TO_RETRY = [
    429,
    502,
    503,
    504
];
module.exports.DEFAULT_STATUS_CODES_TO_RETRY = $0bb5a884626b2eaa$var$DEFAULT_STATUS_CODES_TO_RETRY;
let $0bb5a884626b2eaa$var$ROUTING;
/**
 * Query request interface.
 */ module.exports.ROUTING = $0bb5a884626b2eaa$var$ROUTING;
(function(ROUTING) {
    ROUTING[ROUTING["AEP_PROFILE_BASED"] = 0] = "AEP_PROFILE_BASED";
    ROUTING[ROUTING["DEFAULT"] = 1] = "DEFAULT";
    ROUTING[ROUTING["REGION_BASED_PER_QUERY"] = 2] = "REGION_BASED_PER_QUERY";
})($0bb5a884626b2eaa$var$ROUTING || (module.exports.ROUTING = $0bb5a884626b2eaa$var$ROUTING = {}));
/**
 * This parameter will be used to specify what headers are automatically added to the API call.
 */ let $0bb5a884626b2eaa$var$FetchScope;
/**
 * Defines the object containing any custom settings that you want to apply to the request. You can
 * also additionally specify the 'auth' parameter to automatically set the Authentication, API key in Headers/Query params.
 *
 * ***Example:***
 *
 * `{auth: 'Header', body: 'xyz', headers: {'Content-Type': 'text/plain'}, method: 'POST'}` or
 * `{auth: 'Header', method: 'GET'}` or
 * `{method: 'GET'}`
 */ module.exports.FetchScope = $0bb5a884626b2eaa$var$FetchScope;
(function(FetchScope) {
    FetchScope["NONE"] = "NONE";
    FetchScope["AUTH"] = "AUTH";
    FetchScope["ORG"] = "ORG";
    FetchScope["SANDBOX"] = "SANDBOX";
    FetchScope["SANDBOX_PLUS"] = "SANDBOX_PLUS";
})($0bb5a884626b2eaa$var$FetchScope || (module.exports.FetchScope = $0bb5a884626b2eaa$var$FetchScope = {}));
/**
 * Provides an interface for fetching resources powered by the global 'fetch' API.
 *
 * ***Example:***
 *
 * ```typescript
 * // performs a window.fetch call
 * let response = await fetch('https://example.com/api/ping');
 *
 * // performs a window.fetch call with Authorization and x-api-key headers set
 * response = await fetch('https://localhost', {auth: 'Header', method: 'GET'});
 *
 * // performs a window.fetch call with user_token and client_id query parameters added to the URL
 * const request = new Request('https://localhost', {
 *   body: JSON.stringify({k: 'v'}),
 *   headers: new Headers(),
 *   method: 'POST'
 * });
 * response = await fetch(request, {auth: 'Header'});
 * ```
 * @param input The resource that you wish to fetch. It can either be the URL of the resource you
 * want to fetch or a Request object.
 * @param init An object containing any custom settings that you want to apply to the request.
 * @returns The promise for the response to the fetch operation.
 */ function $0bb5a884626b2eaa$var$fetch(input, init) {
    return (0, $lcrxv.getImpl)("network").fetch(input, init);
}
/**
 * Provides an interface for querying known data.
 * Data querying and caching are managed in Unified Shell in advance.
 *
 * This is an experimental feature.
 * @template T
 * @param key - Data Contract key
 * @param options - Prefetch options
 * @returns Promise for the contract execution response
 */ function $0bb5a884626b2eaa$var$getPrefetched(key, options) {
    return (0, $lcrxv.getImpl)("network").getPrefetched(key, options);
}
/**
 * Provides an interface for querying resources via GraphqQL.
 * In order to consume query, please make sure the respective query resolver is
 * available in the GraphQL Service.
 * ***Example:***
 *
 * ```typescript
 * const PPS_QUERY = `
 *   query PPSQuery($userId: String!, $apiKey: String!) {
 *     getPPSProfile(userId: $userId, apiKey: $apiKey) {
 *       images
 *     }
 *   }`;
 *
 * // queries the respective resource via GraphQL and returns HTTP Response {ok: true, status: 200, ...}
 * query({data: {query: PPS_QUERY, variables: {
 *   userId: '123@AdobeID',
 *   apiKey: 'test-app',
 * }}, operationName: 'PPSAvatar'});
 *
 * // queries the respective resource via GraphQL and returns HTTP Response {ok: true, status: 200, ...}
 * query({data: {query: `
 *   query PPSQuery {
 *     getPPSProfile(userId: "123@AdobeID", apiKey: "test-app") {
 *       images
 *     }
 *   }`
 * }});
 * ```
 * @param input Query request containing desired GQL Query.
 * @returns The promise for the response to the query operation.
 */ function $0bb5a884626b2eaa$var$query(input) {
    return (0, $lcrxv.getImpl)("network").query(input);
}
/**
 * Provides an interface for querying resources via GraphqQL using ApolloClient
 * ***Example***
 * ```typescript
 *  const apolloClientModule = await getApolloClient();
 *  const apolloClient = apolloClientModule.apolloClient;
 *  const gql = apolloClientModule.gql;
 *  const result = await apolloClient.query({
 *    query: gql`query  user {
 *      id
 *      name
 *    }`,
 *    variables : {}
 *  });
 *  console.log(result.data);
 * ```
 * @param options Configuration to create ApolloClient instance
 * @returns GraphQL query response
 *
 */ function $0bb5a884626b2eaa$var$getApolloClient(options) {
    return (0, $lcrxv.getImpl)("network").getApolloClient(options);
}
function $0bb5a884626b2eaa$var$createApolloClient(apolloClientProvided, options) {
    return (0, $lcrxv.getImpl)("network").createApolloClient(apolloClientProvided, options);
}

});
parcelRegister("lcrxv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getImpl = $8d1badf5e964c49f$var$getImpl;
module.exports.connect = $8d1badf5e964c49f$var$connect;
module.exports.default = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module "index"
 */ /**
 * Gets the implementation for the module.
 * @ignore
 * @param moduleName The name of the module.
 * @returns The implementation.
 */ function $8d1badf5e964c49f$var$getImpl(moduleName) {
    const emr = window["exc-module-runtime"];
    if (!emr) throw new Error(`module-runtime APIs not available (Fetching ${moduleName}).`);
    return emr[moduleName];
}
/**
 * Connects attributes of the specified API.
 * @ignore
 * @param apiName Name of the API.
 * @param attributes The attributes to connect.
 * @returns The API instance.
 */ function $8d1badf5e964c49f$var$connect(apiName, attributes) {
    const api = {};
    attributes.forEach((feature)=>{
        const featureName = feature[0];
        if (feature[1]) api[featureName] = (...args)=>{
            return $8d1badf5e964c49f$var$getImpl(apiName)[featureName](...args);
        };
        else Object.defineProperty(api, featureName, {
            get: ()=>{
                return $8d1badf5e964c49f$var$getImpl(apiName)[featureName];
            },
            set: (value)=>{
                $8d1badf5e964c49f$var$getImpl(apiName)[featureName] = value;
            }
        });
    });
    return api;
}
var $8d1badf5e964c49f$var$_default = window;
module.exports.default = $8d1badf5e964c49f$var$_default;

});


parcelRegister("461Ry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $2fb92ae052dad668$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ class $2fb92ae052dad668$var$InvalidStatusCodeError extends Error {
    constructor(message, response){
        super(message);
        $2fb92ae052dad668$var$_defineProperty(this, "_response", void 0);
        this._response = response;
    }
    get status() {
        return this._response.status;
    }
    get response() {
        return this._response.clone();
    }
}
module.exports.default = $2fb92ae052dad668$var$InvalidStatusCodeError;

});

parcelRegister("fBGTm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Events", {
    enumerable: true,
    get: function() {
        return $88iae.Events;
    }
});
Object.defineProperty(module.exports, "Level", {
    enumerable: true,
    get: function() {
        return $f9A5f.Level;
    }
});
module.exports.default = void 0;

var $lcrxv = parcelRequire("lcrxv");

var $88iae = parcelRequire("88iae");

var $f9A5f = parcelRequire("f9A5f");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * API used to log messages, errors, events, metrics and analytics that get pushed to our telemetry
 * system.
 *
 * The main goal of this project is to provide solutions that are integrating with Unified-Shell and
 * running on Adobe Experience Cloud as much telemetry information as possible "for free" and a
 * convenient integration option to collect custom, application specific metrics.
 *
 * ***Import:***
 *
 * ```typescript
 * import metrics from '@adobe/exc-app/metrics';
 * ```
 *
 * ***Type:***
 *
 * [MetricsApi](../interfaces/metrics.metricsapi.md#interface-metricsapi)
 *
 * ***Usage:***
 *
 * ```typescript
 * import metrics from '@adobe/exc-app/metrics';
 *
 * class MyClass {
 *   constructor() {
 *     this.metrics = metrics.create('exc.landing-page.recents');
 *   }
 *
 *   async someOperation() {
 *     const timer = this.metrics.start('MyClass.someOperation');
 *     try {
 *       await performOperation();
 *       timer.time('done');
 *     } catch(err) {
 *       this.metrics.error(error);
 *       throw err;
 *     }
 *   }
 * }
 * ```
 * @packageDocumentation
 * @module metrics
 * @preferred
 */ const $0a6353d7e426372d$var$api = (0, $lcrxv.connect)("metrics", [
    [
        "create",
        true
    ]
]);
var $0a6353d7e426372d$var$_default = $0a6353d7e426372d$var$api;
/**
 * @ignore
 */ /**
 * @ignore
 */ module.exports.default = $0a6353d7e426372d$var$_default;

});
parcelRegister("88iae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Named events in loading lifecycle
 */ /**
 * @ignore
 */ let $1f0a16db85a642a2$var$Events;
module.exports.Events = $1f0a16db85a642a2$var$Events;
(function(Events) {
    Events["PAGE_LOAD_DONE"] = "exc.metrics.pageState.load.done";
    Events["PAGE_LOAD_START"] = "exc.metrics.pageState.load.start";
    Events["SPINNER_DONE"] = "exc.metrics.pageState.spinner.done";
    Events["SPINNER_START"] = "exc.metrics.pageState.spinner.start";
})($1f0a16db85a642a2$var$Events || (module.exports.Events = $1f0a16db85a642a2$var$Events = {}));

});


parcelRegister("8WsMI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.statusAwareFetch = $682a118dd4db46aa$var$statusAwareFetch;

var $lg0Zk = parcelRequire("lg0Zk");

var $682a118dd4db46aa$var$_invalidStatusCodeError = $682a118dd4db46aa$var$_interopRequireDefault((parcelRequire("461Ry")));

var $f9A5f = parcelRequire("f9A5f");
function $682a118dd4db46aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ async function $682a118dd4db46aa$var$statusAwareFetch(input, init, defaultToken, win, logger, messenger) {
    const { fetch: fetch } = win;
    const { statusCodesToRetry: statusCodesToRetry = [] } = init;
    const response = await fetch(input, init);
    if (response.status === 401) {
        const headers = init.headers || new Headers();
        const token = headers.get("authorization");
        if (!token) {
            // Log a potential implementation error. imsClientId is first as that's
            // the backwards compatible way that this value was used. apiKey will
            // have the default value set by Shell.
            const appId = init.metadata?.imsClientId || init.metadata?.apiKey || "";
            logger.event("fetchUtils.noToken", {
                level: $f9A5f.Level.WARN
            }, {
                appId: appId,
                url: response.url
            });
        } else if (token.includes(defaultToken) && messenger) messenger.send($lg0Zk.Events.LOST_AUTH, response.url);
    } // Only check status codes to retry if response is not ok.
    if (!response.ok && statusCodesToRetry.includes(response.status)) throw new $682a118dd4db46aa$var$_invalidStatusCodeError.default(`${response.status} ${response.statusText}`, response);
    return response;
}

});

parcelRegister("1GjWl", function(module, exports) {


module.exports = (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("4hozC")).then(()=>parcelRequire("2IOtP"));

});


parcelRegister("io0Nk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5BWqp = parcelRequire("5BWqp");

var $lg0Zk = parcelRequire("lg0Zk");

var $fBGTm = parcelRequire("fBGTm");

var $d62b15a7a76baa8e$var$_v = $d62b15a7a76baa8e$var$_interopRequireDefault((parcelRequire("dd4La")));
function $d62b15a7a76baa8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $d62b15a7a76baa8e$var$XQL = "xql";
const $d62b15a7a76baa8e$var$NA = "unknown";
function $d62b15a7a76baa8e$var$logGqlError(logger, error, input, requestId = $d62b15a7a76baa8e$var$NA, requestNoAuth = $d62b15a7a76baa8e$var$NA) {
    const { appId: appId, operationName: operationName, routing: routing } = input;
    logger.event("GraphQL.Error", error, {
        appId: appId,
        error: error,
        operationName: operationName,
        requestId: requestId,
        requestNoAuth: requestNoAuth,
        routing: routing
    }, {
        level: $fBGTm.Level.ERROR
    });
}
const $d62b15a7a76baa8e$var$logInvalidScopeForGraphqlProvided = (logger, input)=>{
    if (input.scope === $5BWqp.FetchScope.NONE) {
        $d62b15a7a76baa8e$var$logGqlError(logger, "FetchScope type None used in graphql query", input);
        throw new Error(`FetchScope type None used in graphql query ${input.operationName}`);
    }
};
const $d62b15a7a76baa8e$var$normalizeQueryInput = (graphQLConfig, input)=>({
        ...input,
        appId: input.appId || graphQLConfig.appId,
        operationName: input.operationName || (!(input.data instanceof Array) ? (0, $lg0Zk.getOperationName)(input.data?.query) : $d62b15a7a76baa8e$var$NA)
    });
const $d62b15a7a76baa8e$var$getRequestOptions = (logger, graphQLConfig, input, win, incomingBody)=>{
    const { acceptLanguage: acceptLanguage, appId: appId, endpoint: endpoint = graphQLConfig.gqlEndpoint, extensions: extensions, operationName: operationName } = input;
    let graphQLQueries = operationName ? {
        operationName: operationName,
        ...input.data
    } : input.data || {};
    if (incomingBody && typeof incomingBody === "string") graphQLQueries = {
        ...graphQLQueries,
        ...JSON.parse(incomingBody)
    };
    if (win.adobeMetrics) {
        const { adobeMetrics: { metricsState: { application: { id: applicationId, version: version } = {
            id: "unknown",
            version: "unknown"
        }, deviceId: deviceId, instanceId: instanceId, windowId: windowId } = {}, pageState: { historyId: historyId } = {}, user: { groupId: groupId, sessionId: sessionId } = {} } } = win;
        const clientContext = {
            applicationId: `${applicationId}:${version}`,
            deviceId: deviceId,
            groupId: groupId,
            historyId: historyId,
            instanceId: instanceId,
            sessionId: sessionId,
            windowId: windowId
        };
        graphQLQueries.extensions = {
            ...graphQLQueries.extensions,
            ...extensions,
            clientContext: clientContext
        };
    }
    let auth = "Body";
    let requestId = (0, $d62b15a7a76baa8e$var$_v.default)();
    let { scope: scope } = input;
    const { apiGatewayUrl: apiGatewayUrl, ioGatewayUrl: ioGatewayUrl, isAWSOrg: isAWSOrg } = graphQLConfig;
    const finalEndpoint = isAWSOrg ? `${ioGatewayUrl}/aws` : apiGatewayUrl;
    let ioEndpoint = `${ioGatewayUrl}/graph/graphql?appId=${appId}`;
    let url = `${finalEndpoint}/api/gql/app/${appId}/graphql?appId=${appId}`;
    if (input.routing === $5BWqp.ROUTING.AEP_PROFILE_BASED) url = `${graphQLConfig.apiGatewayUrl}/api/gql/profile/graphql/graphql?appId=${appId}`;
    else if (input.routing === $5BWqp.ROUTING.REGION_BASED_PER_QUERY) {
        if (input.preferredRegion) url = `${graphQLConfig.apiGatewayUrl}/api/gql/region/${input.preferredRegion}/app/${appId}/graphql?appId=${appId}`;
        else logger.warn("REGION_BASED_PER_QUERY routing requested, but region not provided", {
            operationName: operationName
        });
    }
    if (endpoint) {
        url = endpoint;
        ioEndpoint = undefined;
    } else if (appId === $d62b15a7a76baa8e$var$XQL && graphQLConfig.xql) {
        // This logic needs to be removed once XQL has moved to federation (EXC-16583)
        url = graphQLConfig.xql;
        auth = "Header";
        scope = scope || $5BWqp.FetchScope.SANDBOX;
        ioEndpoint = undefined;
        requestId = undefined; // Remove once XQL updated its CORS configuration.
    }
    let ioRegionSpecificMap;
    if (input.regionEnabled) ioRegionSpecificMap = graphQLConfig.ioRegionSpecificMap;
    $d62b15a7a76baa8e$var$logInvalidScopeForGraphqlProvided(logger, input);
    return {
        init: {
            auth: auth,
            body: JSON.stringify(graphQLQueries),
            headers: {
                "Accept-Language": acceptLanguage || "*",
                "Content-Type": "application/json"
            },
            maxRetries: input.maxRetries,
            metadata: input.metadata,
            method: "POST",
            requestId: requestId,
            scope: scope,
            statusCodesToRetry: input.statusCodesToRetry || $5BWqp.DEFAULT_STATUS_CODES_TO_RETRY,
            totalFetchTime: input.totalFetchTime
        },
        ioEndpoint: ioEndpoint,
        ioRegionSpecificMap: ioRegionSpecificMap,
        url: url
    };
};
const $d62b15a7a76baa8e$var$getRequestId = (res)=>res.headers?.get("x-request-id") || $d62b15a7a76baa8e$var$NA;
/**
 * Reduce the data to a boolean map of the data keys and whether they are null or not.
 * @param json - GraphQL response
 */ const $d62b15a7a76baa8e$var$getDataStats = (json)=>{
    if (json.data && typeof json.data === "object") return Object.keys(json.data).reduce((acc, key)=>{
        acc[key] = json.data[key] !== null;
        return acc;
    }, {});
    return null;
};
const $d62b15a7a76baa8e$var$parseJsonSafe = (text)=>{
    try {
        return JSON.parse(text);
    } catch (e) {
        return {
            valid: false
        };
    }
};
var $d62b15a7a76baa8e$var$_default = (fetchFn, metricsApi, win)=>{
    const logger = metricsApi.create("exc.module-runtime.network.graphql");
    const ioRegionMap = {};
    let graphQLConfig = {
        apiGatewayUrl: "",
        appId: "",
        gqlEndpoint: "",
        ioGatewayUrl: "",
        ioRegionSpecificMap: ioRegionMap,
        isAWSOrg: false,
        xql: ""
    };
    const baseQuery = async (input, body, client = "query")=>{
        const start = Date.now();
        const normalizedInput = $d62b15a7a76baa8e$var$normalizeQueryInput(graphQLConfig, input);
        const { appId: appId, operationName: operationName, routing: routing } = normalizedInput;
        const reqOpts = $d62b15a7a76baa8e$var$getRequestOptions(logger, graphQLConfig, normalizedInput, win, body);
        const { requestId: requestId } = reqOpts.init;
        const logData = {
            appId: appId,
            client: client,
            operationName: operationName,
            requestId: requestId,
            routing: routing
        };
        const timer = logger.start(`GraphQL.Query`, operationName || "query", {
            ...logData
        });
        try {
            const response = await fetchFn(reqOpts.url, reqOpts.init, reqOpts.ioEndpoint, reqOpts.ioRegionSpecificMap); // Measuring duration here to provide a net duration not including event loop lag.
            const duration = Date.now() - start;
            const { headers: headers, ok: ok, status: status, statusText: statusText } = response;
            logData.requestId = $d62b15a7a76baa8e$var$getRequestId(response);
            const requestWithoutAuthorization = headers?.get("has-authorization") || $d62b15a7a76baa8e$var$NA;
            response.clone().text().then((responseText)=>{
                // Attempt to parse the response as JSON, if it fails, log the raw response.
                const json = $d62b15a7a76baa8e$var$parseJsonSafe(responseText);
                const data = $d62b15a7a76baa8e$var$getDataStats(json);
                const valid = ok && data !== null && (json.errors === undefined || json.errors.length === 0);
                timer.time("done", operationName || "query", {
                    ...logData,
                    data: data,
                    duration: duration,
                    errors: json.errors,
                    ok: ok,
                    status: status,
                    statusText: statusText,
                    valid: valid
                }, {
                    level: valid ? $fBGTm.Level.INFO : $fBGTm.Level.ERROR
                });
                ok || $d62b15a7a76baa8e$var$logGqlError(logger, responseText || "Unknown error", normalizedInput, requestId, requestWithoutAuthorization);
            });
            return response;
        } catch (err) {
            const duration = Date.now() - start;
            const error = err instanceof Error ? err.message : "Unknown error";
            timer.time("done", operationName || "query", {
                ...logData,
                duration: duration,
                error: error,
                ok: false,
                status: 0,
                statusText: "NETWORK ERROR",
                valid: false
            }, {
                level: $fBGTm.Level.ERROR
            });
            $d62b15a7a76baa8e$var$logGqlError(logger, error, normalizedInput, requestId);
            throw err || new Error("Unknown error");
        }
    };
    return {
        baseQuery: baseQuery,
        configure: ({ apiGatewayUrl: apiGatewayUrl, appId: appId, gqlEndpoint: gqlEndpoint, ioGatewayUrl: ioGatewayUrl, ioRegionSpecificMap: ioRegionSpecificMap, isAWSOrg: isAWSOrg, xqlGatewayUrl: xqlGatewayUrl })=>{
            graphQLConfig = {
                apiGatewayUrl: apiGatewayUrl,
                appId: appId,
                gqlEndpoint: gqlEndpoint || "",
                ioGatewayUrl: ioGatewayUrl || "",
                ioRegionSpecificMap: ioRegionSpecificMap || {},
                isAWSOrg: isAWSOrg || false,
                xql: xqlGatewayUrl || ""
            };
        },
        query: (input)=>baseQuery(input)
    };
};
module.exports.default = $d62b15a7a76baa8e$var$_default;

});

parcelRegister("fQPSB", function(module, exports) {


module.exports = (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("9Xl1b")).then(()=>parcelRequire("2kvT4"));

});


parcelRegister("baCFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
var $821e9f3513bd1c03$var$_default = (messenger, configManager)=>{
    // This is now deprecated in favor of the Total User Experience (TUX) survey
    // delivered by Unified Shell.
    // Remove this once all solutions have transitioned to TUX.
    const npsInstance = {
        triggerNps: ()=>messenger.send($lg0Zk.Events.DEPRECATION_WARNING, "nps")
    };
    configManager.setupConfig(npsInstance, [
        "config"
    ], ()=>messenger.send($lg0Zk.Events.DEPRECATION_WARNING, "nps"));
    return npsInstance;
};
module.exports.default = $821e9f3513bd1c03$var$_default;

});

parcelRegister("5IiZj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $428fca6a3aa2c537$var$_default = (configManager)=>{
    const orgSwitcherInstance = {};
    configManager.setupConfig(orgSwitcherInstance, [
        "subOrgs"
    ]);
    return orgSwitcherInstance;
};
module.exports.default = $428fca6a3aa2c537$var$_default;

});

parcelRegister("7fsvi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addShellPlaceholder = $54700b5d2bb1667f$var$addShellPlaceholder;
module.exports.default = module.exports.OBSERVER_DEFAULT_SELECTORS = void 0;

var $9s7Ng = parcelRequire("9s7Ng");

var $lg0Zk = parcelRequire("lg0Zk");

var $eYPZ6 = parcelRequire("eYPZ6");

var $hEZsy = parcelRequire("hEZsy");

var $54700b5d2bb1667f$var$_observer = $54700b5d2bb1667f$var$_interopRequireDefault((parcelRequire("5YI9D")));
function $54700b5d2bb1667f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This is the default popover selector that should be connected to the modal
// list of selectors because it was there in the previous implementation. This
// must be separated because it was always included and could not be overridden.
const $54700b5d2bb1667f$var$DEFAULT_POPOVER_SELECTOR = '[data-testid="popover"]';
const $54700b5d2bb1667f$var$OBSERVER_DEFAULT_SELECTORS = {
    [$hEZsy.ObservableType.MODAL]: [
        '[role="dialog"]',
        '[role="alertdialog"]',
        $54700b5d2bb1667f$var$DEFAULT_POPOVER_SELECTOR
    ],
    [$hEZsy.ObservableType.POPOVER]: [
        '[class*="spectrum-Popover"]'
    ]
};
module.exports.OBSERVER_DEFAULT_SELECTORS = $54700b5d2bb1667f$var$OBSERVER_DEFAULT_SELECTORS;
function $54700b5d2bb1667f$var$addShellPlaceholder(document, runtimeMessenger) {
    if (document.getElementById("shell-placeholder")) return;
    const div = document.createElement("div");
    div.id = "shell-placeholder";
    document.body.insertBefore(div, document.body.childNodes[0]);
    runtimeMessenger.send($lg0Zk.Events.CAN_TAKEOVER, {});
}
var $54700b5d2bb1667f$var$_default = (messenger, configManager, metricsApi, window)=>{
    const { document: document, performance: performance } = window;
    let configuration;
    const metrics = metricsApi.create("exc.module-runtime.page");
    let observer; // Initialize the observable selectors, which can be overridden by developers.
    const observerSelectors = {
        [$hEZsy.ObservableType.MODAL]: [
            ...$54700b5d2bb1667f$var$OBSERVER_DEFAULT_SELECTORS[$hEZsy.ObservableType.MODAL]
        ],
        [$hEZsy.ObservableType.POPOVER]: [
            ...$54700b5d2bb1667f$var$OBSERVER_DEFAULT_SELECTORS[$hEZsy.ObservableType.POPOVER]
        ]
    };
    const pageInstance = {
        afterPrintHandler: (callback)=>{
            messenger.send($lg0Zk.Events.AFTER_PRINT_HANDLER);
            messenger.setCallback($lg0Zk.Events.AFTER_PRINT_HANDLER, callback);
        },
        beforePrintHandler: (callback)=>{
            messenger.send($lg0Zk.Events.BEFORE_PRINT_HANDLER);
            messenger.setCallback($lg0Zk.Events.BEFORE_PRINT_HANDLER, callback);
        },
        blockNavigation: (enabled, options)=>{
            messenger.send($lg0Zk.Events.BLOCK_NAVIGATION, {
                enabled: enabled,
                options: options
            });
        },
        clipboardWrite: (msg)=>{
            messenger.send($lg0Zk.Events.CLIPBOARD_WRITE, {
                msg: msg
            });
        },
        done: ()=>(0, $9s7Ng.done)(performance.now(), messenger, metricsApi, window),
        generateShellUrl: (location, newApp)=>(0, $eYPZ6.generateShellUrl)(configuration, location, newApp),
        getModalQuerySelectors: ()=>pageInstance.getObservableQuerySelectors($hEZsy.ObservableType.MODAL),
        getObservableQuerySelectors: (type)=>observerSelectors[type],
        iframeReload: (cacheBust)=>{
            messenger.send($lg0Zk.Events.IFRAME_RELOAD, {
                cacheBust: cacheBust === undefined ? !configuration.spaAppId : cacheBust
            });
        },
        notFound: ()=>{
            messenger.send($lg0Zk.Events.NOT_FOUND, {});
        },
        openInNewTab: (path, newApp)=>{
            window.open(pageInstance.generateShellUrl({
                path: path
            }, newApp));
        },
        print: (callback)=>{
            messenger.setCallback($lg0Zk.Events.PRINT_NOW, callback);
            messenger.send($lg0Zk.Events.PRINT_NOW);
        },
        reloadSandbox: ()=>{
            messenger.send($lg0Zk.Events.DEPRECATION_WARNING, "reloadSandbox");
        },
        setModalQuerySelectors: (selectors)=>{
            metrics.event("OverlayAction", {
                setModalQuerySelectors: {
                    selectors: selectors
                }
            });
            pageInstance.setObservableQuerySelectors($hEZsy.ObservableType.MODAL, selectors);
        },
        setObservableQuerySelectors: (type, selectors, forceCustomOnly)=>{
            metrics.event("OverlayAction", {
                setObservableQuerySelectors: {
                    selectors: selectors,
                    type: type
                }
            });
            observerSelectors[type] = selectors?.length ? selectors : $54700b5d2bb1667f$var$OBSERVER_DEFAULT_SELECTORS[type]; // Current functionality includes a default popover selector with modals.
            // Adding the `forceCustomOnly` param will remove it.
            if (!forceCustomOnly && type === $hEZsy.ObservableType.MODAL && observerSelectors[type].indexOf($54700b5d2bb1667f$var$DEFAULT_POPOVER_SELECTOR) === -1) observerSelectors[type].push($54700b5d2bb1667f$var$DEFAULT_POPOVER_SELECTOR);
        },
        shellRedirect: (pathOrUrl, options)=>{
            const property = pathOrUrl.startsWith("https:") ? "url" : "path";
            messenger.send($lg0Zk.Events.SHELL_REDIRECT, {
                ...options,
                [property]: pathOrUrl
            });
        },
        toggleAutoDetect: async (type, enable)=>{
            if (enable) {
                observer || (observer = new $54700b5d2bb1667f$var$_observer.default(document.body, window));
                observer.observe({
                    ...OBSERVED_MAP[type],
                    id: type
                });
            } else observer.unobserve(type);
            metrics.event("OverlayAction", {
                toggleAutoDetect: {
                    enable: enable,
                    type: type
                }
            });
        }
    }; // Map of observed properties to their configs that the observer will use.
    const OBSERVED_MAP = {
        [$hEZsy.ObservableType.MODAL]: {
            callback: (added)=>{
                const selectors = pageInstance.getObservableQuerySelectors($hEZsy.ObservableType.MODAL).join(",");
                if (added || !document.querySelectorAll(selectors).length) pageInstance.modal = added;
            },
            getSelectors: ()=>pageInstance.getObservableQuerySelectors($hEZsy.ObservableType.MODAL)
        },
        [$hEZsy.ObservableType.POPOVER]: {
            // eslint-disable-next-line no-restricted-globals
            callback: (added, el)=>setTimeout(()=>{
                    const element = el; // If the popover was removed or the element does not exist, there is
                    // nothing more to do.
                    if (!added || !element) return;
                    const { shellHeight: shellHeight } = configuration;
                    const minTopPosition = shellHeight + 10; // Only resize if the element is underneath the Shell header. Adjust the
                    // position check for window scroll to ensure that the popover is always
                    // correctly resized for accessibility purposes.
                    if (element.offsetTop > minTopPosition + window.scrollY) return;
                    const newHeight = element.offsetHeight - (minTopPosition - element.offsetTop + window.scrollY);
                    element.style.height = `${newHeight}px`;
                }, 20),
            getSelectors: ()=>pageInstance.getObservableQuerySelectors($hEZsy.ObservableType.POPOVER)
        }
    };
    configManager.setupConfig(pageInstance, [
        "appContainer",
        "favicon",
        "modal",
        "modalAutoDetect",
        "preventDefaultCombos",
        "spinner",
        "title",
        "unloadPromptMessage"
    ], (apiName, value)=>{
        // If appContainer is set, add the placeholder element to the DOM. This
        // will be how the application maintains the existing UI when appContainer
        // is enabled.
        if (value && apiName === "appContainer") $54700b5d2bb1667f$var$addShellPlaceholder(document, messenger);
         // Legacy usage for modalAutoDetect. Uses the new toggleAutoDetect API to
        // toggle the observer on/off depending on `value`.
        if (apiName === "modalAutoDetect") {
            metrics.event("OverlayAction", {
                modalAutoDetect: {
                    value: value
                }
            });
            pageInstance.toggleAutoDetect($hEZsy.ObservableType.MODAL, value);
        }
    });
    return {
        addShellPlaceholder: ()=>$54700b5d2bb1667f$var$addShellPlaceholder(document, messenger),
        OBSERVED_MAP: OBSERVED_MAP,
        onConfigure: (config)=>{
            configuration = config;
        },
        page: pageInstance
    };
};
module.exports.default = $54700b5d2bb1667f$var$_default;

});
parcelRegister("hEZsy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.THUNDERBIRD = module.exports.SRC_DOC = module.exports.RELEASE_TYPE = module.exports.RELEASE_SCOPE = module.exports.ObservableType = void 0;

var $lcrxv = parcelRequire("lcrxv");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs that let solutions interact with the main page and personalize it, e.g. setting the title,
 * favicon, refreshing the solution iframe, etc.
 *
 * ***Import:***
 *
 * ```typescript
 * import page from '@adobe/exc-app/page';
 * ```
 *
 * ***Default export:***
 *
 * [PageApi](../interfaces/page.pageapi.md#interface-pageapi)
 *
 * ***Usage:***
 *
 * ```typescript
 * import page from '@adobe/exc-app/page';
 *
 * page.title = 'Experience Cloud';
 *
 * // Show spinner while performing an async operation
 * page.spinner = true;
 * try {
 *   await performOperation();
 * } finally {
 *   page.spinner = false;
 * }
 *
 * // Generate a shell URL that directly opens the specified solution URL
 * const shellUrl = page.generateShellUrl('/relative/path');
 *
 * // Navigate to another solution
 * page.shellRedirect('/target');
 * ```
 * @packageDocumentation
 * @module page
 */ let $a6fecd7df25a4b85$var$ObservableType;
/**
 * Scope for the solution's release type in the product lifecycle
 */ module.exports.ObservableType = $a6fecd7df25a4b85$var$ObservableType;
(function(ObservableType) {
    ObservableType["MODAL"] = "MODAL";
    ObservableType["POPOVER"] = "POPOVER";
})($a6fecd7df25a4b85$var$ObservableType || (module.exports.ObservableType = $a6fecd7df25a4b85$var$ObservableType = {}));
let $a6fecd7df25a4b85$var$RELEASE_SCOPE;
/**
 * Solution's release type in the product lifecycle
 */ module.exports.RELEASE_SCOPE = $a6fecd7df25a4b85$var$RELEASE_SCOPE;
(function(RELEASE_SCOPE) {
    RELEASE_SCOPE["PARENT"] = "parent";
    RELEASE_SCOPE["SELF"] = "self";
})($a6fecd7df25a4b85$var$RELEASE_SCOPE || (module.exports.RELEASE_SCOPE = $a6fecd7df25a4b85$var$RELEASE_SCOPE = {}));
let $a6fecd7df25a4b85$var$RELEASE_TYPE;
/**
 * @deprecated Solution's list of multiple subdomains
 */ module.exports.RELEASE_TYPE = $a6fecd7df25a4b85$var$RELEASE_TYPE;
(function(RELEASE_TYPE) {
    RELEASE_TYPE["POC"] = "poc";
    RELEASE_TYPE["DEV"] = "dev";
    RELEASE_TYPE["ALPHA"] = "alpha";
    RELEASE_TYPE["BETA"] = "beta";
    RELEASE_TYPE["GA"] = "ga";
})($a6fecd7df25a4b85$var$RELEASE_TYPE || (module.exports.RELEASE_TYPE = $a6fecd7df25a4b85$var$RELEASE_TYPE = {}));
let $a6fecd7df25a4b85$var$SRC_DOC;
module.exports.SRC_DOC = $a6fecd7df25a4b85$var$SRC_DOC;
(function(SRC_DOC) {
    SRC_DOC[SRC_DOC["DISABLED"] = 0] = "DISABLED";
    SRC_DOC[SRC_DOC["HTML"] = 1] = "HTML";
    SRC_DOC[SRC_DOC["MANIFEST"] = 2] = "MANIFEST";
})($a6fecd7df25a4b85$var$SRC_DOC || (module.exports.SRC_DOC = $a6fecd7df25a4b85$var$SRC_DOC = {}));
let $a6fecd7df25a4b85$var$THUNDERBIRD;
module.exports.THUNDERBIRD = $a6fecd7df25a4b85$var$THUNDERBIRD;
(function(THUNDERBIRD) {
    THUNDERBIRD[THUNDERBIRD["OFF"] = 0] = "OFF";
    THUNDERBIRD[THUNDERBIRD["SRC_DOC"] = 1] = "SRC_DOC";
    THUNDERBIRD[THUNDERBIRD["SERVICE_WORKER"] = 2] = "SERVICE_WORKER";
})($a6fecd7df25a4b85$var$THUNDERBIRD || (module.exports.THUNDERBIRD = $a6fecd7df25a4b85$var$THUNDERBIRD = {}));
const $a6fecd7df25a4b85$var$page = (0, $lcrxv.connect)("page", [
    [
        "afterPrintHandler"
    ],
    [
        "appContainer"
    ],
    [
        "beforePrintHandler"
    ],
    [
        "blockNavigation",
        true
    ],
    [
        "clipboardWrite",
        true
    ],
    [
        "done",
        true
    ],
    [
        "generateShellUrl",
        true
    ],
    [
        "getModalQuerySelectors"
    ],
    [
        "getObservableQuerySelectors"
    ],
    [
        "favicon"
    ],
    [
        "iframeReload",
        true
    ],
    [
        "modal"
    ],
    [
        "modalAutoDetect"
    ],
    [
        "notFound",
        true
    ],
    [
        "openInNewTab",
        true
    ],
    [
        "preventDefaultCombos"
    ],
    [
        "print",
        true
    ],
    [
        "reloadSandbox",
        true
    ],
    [
        "shellRedirect",
        true
    ],
    [
        "setModalQuerySelectors"
    ],
    [
        "setObservableQuerySelectors"
    ],
    [
        "spinner"
    ],
    [
        "title"
    ],
    [
        "toggleAutoDetect"
    ],
    [
        "unloadPromptMessage"
    ]
]);
var $a6fecd7df25a4b85$var$_default = $a6fecd7df25a4b85$var$page;
module.exports.default = $a6fecd7df25a4b85$var$_default;

});

parcelRegister("5YI9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $45a4ce7f110d3a56$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $45a4ce7f110d3a56$var$Observer {
    // eslint-disable-next-line no-restricted-globals
    constructor(body, window){
        $45a4ce7f110d3a56$var$_defineProperty(this, "observedElement", void 0);
        $45a4ce7f110d3a56$var$_defineProperty(this, "observed", {});
        $45a4ce7f110d3a56$var$_defineProperty(this, "observer", void 0);
        const { MutationObserver: MutationObserver } = window;
        this.observedElement = body;
        this.observer = new MutationObserver((mutationsList)=>{
            const processNodes = (node, added)=>{
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                Object.values(this.observed).forEach((observed)=>this.processNode(node, added, observed));
            };
            mutationsList.forEach((mutation)=>{
                mutation.addedNodes.forEach((node)=>processNodes(node, true));
                mutation.removedNodes.forEach((node)=>processNodes(node, false));
            });
        });
    }
    observe(toObserve) {
        const { id: id } = toObserve;
        this.observed[id] = toObserve;
        this.toggleObserver();
    }
    processNode(node, added, observed) {
        const el = node;
        const { callback: callback, getSelectors: getSelectors } = observed;
        const selectors = getSelectors().join(",");
        let matchedElement = el.matches(selectors) ? el : null;
        matchedElement = matchedElement || el.querySelector(selectors); // If there is no matching element, don't trigger the callback. This will
        // happen on all add or remove nodes that do not match the selector.
        if (!matchedElement) return;
         // Since the generic observer handles N types, it's possible that additions
        // and removals happen at various timings and we need to make sure there
        // was an addition or removal to this id before firing a callback.
        callback(added, added ? matchedElement : undefined);
    }
    toggleObserver() {
        const enable = Object.keys(this.observed).length > 0;
        enable && this.observer.observe(this.observedElement, {
            childList: true,
            subtree: true
        });
        enable || this.observer.disconnect();
    }
    unobserve(type) {
        delete this.observed[type];
        this.toggleObserver();
    }
}
module.exports.default = $45a4ce7f110d3a56$var$Observer;

});


parcelRegister("gvbcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
var $c0383bb6282f0c81$var$_default = (messenger, configManager)=>{
    // This is now deprecated in favor of the sidenav api, which should be used instead.
    // Remove this once all solutions have been transitioned to sidenav.
    const sidebar = {};
    configManager.setupConfig(sidebar, [
        "config",
        "collapsed",
        "visible"
    ], ()=>messenger.send($lg0Zk.Events.DEPRECATION_WARNING, "sidebar"), "sidebar");
    return sidebar;
};
module.exports.default = $c0383bb6282f0c81$var$_default;

});

parcelRegister("bXSTM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
var $8b5fca23581740b7$var$_default = (messenger, configManager)=>{
    const topbarInstance = {
        onHeroClick: (callback)=>{
            messenger.send($lg0Zk.Events.CUSTOM_HERO_CLICK);
            messenger.setCallback($lg0Zk.Events.HERO_CLICK, callback);
        },
        setCoachMark: (coachMark)=>{
            if (!coachMark) {
                configManager.clear("coachMark");
                return;
            }
            configManager.update("coachMark", coachMark, $lg0Zk.Events.COACH_MARK_POSITIONED);
        },
        setCustomSearch: (customSearch)=>{
            if (!customSearch) {
                configManager.clear("customSearch", $lg0Zk.Events.CUSTOM_SEARCH);
                return;
            }
            configManager.update("customSearch", customSearch, $lg0Zk.Events.CUSTOM_SEARCH);
        },
        setFeedbackButton: (feedback)=>{
            if (!feedback) {
                configManager.clear("feedback", $lg0Zk.Events.CUSTOM_FEEDBACK);
                return;
            }
            configManager.update("feedback", feedback, $lg0Zk.Events.CUSTOM_FEEDBACK, feedback.type !== "custom");
        }
    };
    configManager.setupConfig(topbarInstance, [
        "customEnvLabel",
        "solution",
        "workspaces"
    ]);
    return topbarInstance;
};
module.exports.default = $8b5fca23581740b7$var$_default;

});

parcelRegister("cW1HM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");
var $96ac39656544b2e4$var$_default = (messenger, configManager)=>({
        setButtons: (buttons)=>{
            let customButtons = configManager.get("customButtons") || []; // Reset customButtons
            if (!buttons || buttons.length === 0) {
                customButtons = customButtons.filter((button)=>button.scope !== "userProfile");
                configManager.set({
                    customButtons: customButtons
                });
                messenger.setCallback($lg0Zk.Events.CUSTOM_PROFILE_BUTTON_CLICK, null);
                return;
            } // Add buttons
            const callbacks = {};
            buttons.forEach(({ callback: callback, id: id, label: label })=>{
                customButtons.unshift({
                    id: id,
                    label: label,
                    scope: "userProfile"
                });
                callbacks[id] = callback;
            });
            configManager.set({
                customButtons: customButtons
            });
            messenger.setCallback($lg0Zk.Events.CUSTOM_PROFILE_BUTTON_CLICK, callbacks);
        }
    });
module.exports.default = $96ac39656544b2e4$var$_default;

});

parcelRegister("9RE5P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eYPZ6 = parcelRequire("eYPZ6");

var $72e829ef4e82c5da$var$_AppControllerService = $72e829ef4e82c5da$var$_interopRequireDefault((parcelRequire("fAza5")));

var $lg0Zk = parcelRequire("lg0Zk");

var $72e829ef4e82c5da$var$_emitter = $72e829ef4e82c5da$var$_interopRequireDefault((parcelRequire("78Nz3")));

var $fBGTm = parcelRequire("fBGTm");
function $72e829ef4e82c5da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $72e829ef4e82c5da$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $72e829ef4e82c5da$var$PING_RETRIES = 2;
const $72e829ef4e82c5da$var$PING_TIMEOUT_MS = 500;
class $72e829ef4e82c5da$var$RuntimeMessengerImpl extends $72e829ef4e82c5da$var$_emitter.default {
    constructor(metricsApiContainer, _win, postMessageFn, appId){
        super();
        $72e829ef4e82c5da$var$_defineProperty(this, "inQueue", []);
        $72e829ef4e82c5da$var$_defineProperty(this, "isConnected", false);
        $72e829ef4e82c5da$var$_defineProperty(this, "origin", "*");
        $72e829ef4e82c5da$var$_defineProperty(this, "queue", []);
        $72e829ef4e82c5da$var$_defineProperty(this, "callbacks", {});
        $72e829ef4e82c5da$var$_defineProperty(this, "appId", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "metrics", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "sandboxId", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "metricsApiContainer", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "postMessage", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "addVersionToMetricsConfig", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "getGlobalRuntime", void 0);
        $72e829ef4e82c5da$var$_defineProperty(this, "send", (type, value)=>{
            // Consolidate Shell Settings Config Event if possible
            if (type === $lg0Zk.Events.SHELL_SETTINGS) {
                const currentValue = this.queue.find(([key])=>key === $lg0Zk.Events.SHELL_SETTINGS);
                if (currentValue) {
                    Object.assign(currentValue[1], value);
                    return;
                }
            } else if (type === $lg0Zk.Events.NOT_INITIALIZED) {
                // Bypass queue.
                this._sendMessage(type);
                return;
            }
            this.queue.push([
                type,
                value
            ]);
            this.flushQueue();
        });
        $72e829ef4e82c5da$var$_defineProperty(this, "connect", (win, retriesLeft = $72e829ef4e82c5da$var$PING_RETRIES)=>{
            const { config: config = {}, setTimeout: setTimeout } = win;
            const { spaAppId: spaAppId, spaVersion: spaVersion } = config;
            if (this.appId) this.sandboxId = $72e829ef4e82c5da$var$_AppControllerService.default.getSandboxId(this.appId);
             // Sends ping event with * as origin because it doesn't contain
            // anything secure, and we need the response of the first received post
            // message to determine what that valid origin is.
            this._sendMessage($lg0Zk.Events.PING, {
                spaAppId: spaAppId,
                spaVersion: spaVersion
            });
            setTimeout(()=>{
                if (!this.isConnected) retriesLeft ? this.connect(win, retriesLeft - 1) : this.metrics.event("Runtime.PingTimeout", {
                    level: $fBGTm.Level.ERROR
                });
            }, $72e829ef4e82c5da$var$PING_TIMEOUT_MS);
        });
        $72e829ef4e82c5da$var$_defineProperty(this, "handlePong", (pongMessage)=>{
            this.isConnected = true;
            if (pongMessage) {
                const { autoInstantiateRuntime: autoInstantiateRuntime, metricsConfig: metricsConfig } = pongMessage;
                const { metricsInternal: { configureMetrics: configureMetrics } } = this.metricsApiContainer;
                const config = this.addVersionToMetricsConfig(metricsConfig); // Many SPAs load Runtime.js early but instantiate the Runtime object later.
                // For these scenarios, we send useful information to the iframe via the PONG
                // event allowing the iframe to send data to EIM and optionally create Runtime early.
                configureMetrics(config); // PONG event is only dependent on the iframe loading Runtime.js
                const globalRuntime = this.getGlobalRuntime();
                if (autoInstantiateRuntime && globalRuntime?.default) {
                    this.metrics.event("Runtime.AutoInstantiate");
                    globalRuntime.default();
                }
            }
            this.metrics.event("Messenger.connected", {
                appId: this.appId
            });
            this.flushQueue();
            this.inQueue.forEach((evt)=>this.receive(evt));
            this.inQueue = [];
        });
        $72e829ef4e82c5da$var$_defineProperty(this, "receive", (event)=>{
            // Ensure the messages always come from adobe.com/io or adobeaemcloud origins.
            if (!/(\/\/|\.)(adobe|adobeaemcloud)\.(com|io)(:\d{4})?$/.test(event.origin)) return;
            const data = event.data || {};
            const type = data.type; // Only accept messages from unified shell
            if (data.unifiedShell !== 1) return;
            if (!this.isConnected) {
                if (type === $lg0Zk.Events.PONG) {
                    this.origin = event.origin;
                    if (this.appId && this.appId !== data.appId) // Need to monitor this error over time, should not happen.
                    this.metrics.event("Messenger.appIdMismatch", {
                        pongAppId: data.appId,
                        urlAppId: this.appId
                    }, {
                        level: $fBGTm.Level.ERROR
                    });
                    this.appId = data.appId;
                    this.handlePong(data.value);
                } else {
                    this.metrics.info(`Event ${type || "unknown"} received before connection - Queueing.`);
                    this.inQueue.push(event);
                    return;
                }
            }
            const value = data.value;
            const cb = this.callbacks[type];
            if (cb) {
                if (typeof cb === "function") cb(value);
                else cb[value.id] && cb[value.id](value);
            }
            this.emit("message", event);
        });
        $72e829ef4e82c5da$var$_defineProperty(this, "setCallback", (type, callback)=>{
            if (!callback) {
                delete this.callbacks[type];
                return;
            }
            this.callbacks[type] = callback;
        });
        this.metricsApiContainer = metricsApiContainer;
        this.appId = appId;
        const { metricsApi: metricsApi } = this.metricsApiContainer;
        this.metrics = metricsApi.create("exc.module-runtime.messenger");
        _win.addEventListener("message", this.receive, false);
        this.postMessage = postMessageFn || ((message, origin, transfer)=>_win.parent?.postMessage(message, origin, transfer));
        this.addVersionToMetricsConfig = (config)=>(0, $eYPZ6.addVersionToMetricsConfig)(config, _win);
        this.getGlobalRuntime = ()=>_win["exc-module-runtime"];
        this.connect(_win); // Wait 16ms/1 frame every time a post message is sent before clearing queue
        this.flushQueue = (0, $lg0Zk.throttleQueue)(this.flushQueue, 16, false, _win);
    }
    _sendMessage(type, value) {
        const message = {
            appId: this.appId,
            type: type,
            unifiedShell: 1,
            value: value
        };
        this.sandboxId ? $72e829ef4e82c5da$var$_AppControllerService.default.sendMessage(this.sandboxId, message, this.origin, this.postMessage) : this.postMessage(message, this.origin);
    }
    flushQueue() {
        // Ensure this.origin is set on the off-chance that we flush queue
        // before receiving the first post message.
        if (this.origin === "*") return;
        this.queue.length > 0 && this._sendMessage($lg0Zk.Events.QUEUE, this.queue);
        this.queue = [];
    }
}
module.exports.default = $72e829ef4e82c5da$var$RuntimeMessengerImpl;

});
parcelRegister("78Nz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $532fba38153cb5ee$var$Emitter = /** @class */ function() {
    function Emitter(all) {
        this.all = all || Object.create(null);
    }
    /**
   * Register an event handler for the given type.
   * @param type Type of event to listen for.
   * @param handler Function to call in response to given event.
   */ Emitter.prototype.on = function(type, handler) {
        (this.all[type] || (this.all[type] = [])).push(handler);
    };
    /**
   * Remove an event handler for the given type.
   * @param type Type of event to unregister `handler` from.
   * @param handler Handler function to remove.
   */ Emitter.prototype.off = function(type, handler) {
        if (this.all[type]) this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
    };
    /**
   * Removes all event handlers to prevent memory leaks.
   */ Emitter.prototype.reset = function() {
        this.all = {};
    };
    /**
   * Invoke all handlers for the given type.
   * @param type The event type to invoke.
   * @param evt Any value (object is recommended and powerful),
   * passed to each handler.
   * @param changed Any changed values if the event encompasses more.
   */ Emitter.prototype.emit = function(type, evt, changed) {
        (this.all[type] || []).slice().forEach(function(handler) {
            return changed ? handler(evt, changed) : handler(evt);
        });
    };
    return Emitter;
}();
var $532fba38153cb5ee$var$_default = $532fba38153cb5ee$var$Emitter;
module.exports.default = $532fba38153cb5ee$var$_default;

});


parcelRegister("3QPMY", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("4tLhU")),
    (parcelRequire("8msKY"))((parcelRequire("fAf6U")).resolve("11kVG"))
]).then(()=>parcelRequire("auWD2"));

});

var $ebe8aa3d5240ee3d$exports = {};


(parcelRequire("fAf6U")).register((parcelRequire("beFBT")).getBundleURL("qLMKz"), JSON.parse('["qLMKz","runtime.2285bdb1.js","4tLhU","runtimeEngine.32d6f046.js","avtKV","events.8235679e.js","Pc7wl","polling.926195c9.js","irvOl","metricsRuntime.40e42a3b.js","4hozC","fetchRetry.34ba4b49.js","9Xl1b","custom-apollo-client.da17bc1e.js","aslBY","client.554f3748.js","11kVG","runtimeNest.8b2b613e.js"]'));

"use strict";

var $95436b040e0d5b18$var$_config = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("do71c")));

var $95436b040e0d5b18$var$_runtimeDeferred = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("9s7Ng")));

var $95436b040e0d5b18$var$_helpcenter = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("iZrqd")));

var $95436b040e0d5b18$var$_internal = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("e04Rl")));

var $95436b040e0d5b18$var$_metrics = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("11Bzf")));

var $95436b040e0d5b18$var$_network = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("lhEz4")));

var $95436b040e0d5b18$var$_nps = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("baCFn")));

var $95436b040e0d5b18$var$_orgswitcher = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("5IiZj")));

var $95436b040e0d5b18$var$_page = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("7fsvi")));

var $95436b040e0d5b18$var$_sidebar = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("gvbcM")));

var $95436b040e0d5b18$var$_topbar = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("bXSTM")));

var $95436b040e0d5b18$var$_userprofile = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("cW1HM")));

var $eYPZ6 = parcelRequire("eYPZ6");

var $95436b040e0d5b18$var$_Messenger = $95436b040e0d5b18$var$_interopRequireDefault((parcelRequire("9RE5P")));
var $47f9a2da236c5b90$exports = {};
"use strict";
Object.defineProperty($47f9a2da236c5b90$exports, "__esModule", {
    value: true
});
$47f9a2da236c5b90$exports.Runtime = $47f9a2da236c5b90$exports.RUNTIME_MARKED_EVENTS = void 0;

var $lg0Zk = parcelRequire("lg0Zk");

var $47f9a2da236c5b90$var$_emitter = $47f9a2da236c5b90$var$_interopRequireDefault((parcelRequire("78Nz3")));

var $fBGTm = parcelRequire("fBGTm");
function $47f9a2da236c5b90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47f9a2da236c5b90$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $47f9a2da236c5b90$var$RUNTIME_MARKED_EVENTS = [
    "Runtime.constructed",
    "Runtime.ready",
    "Runtime.readyBeforeListen",
    "Runtime.done",
    "Messenger.connected"
]; // When a global shell component is open (i.e. Unified Nav or Global Search),
// we need to hide the solution's main content from the accessibility tree.
$47f9a2da236c5b90$exports.RUNTIME_MARKED_EVENTS = $47f9a2da236c5b90$var$RUNTIME_MARKED_EVENTS;
const $47f9a2da236c5b90$var$setHidden = (hide, body)=>body.setAttribute("aria-hidden", hide.toString());
class $47f9a2da236c5b90$var$Runtime extends $47f9a2da236c5b90$var$_emitter.default {
    // Backwards compatibility: @adobe/exc-app 0.2.27 and earlier.
    // 0.2.28+
    // Configuration proxy -- see proxiedConfig for accessors
    /**
   * Called when user's auth expires or times out and user has to
   * log in again.
   */ /**
   * Method called from solution to open link in a new tab.
   * @param path Relative path.
   */ /**
   * Redirects to another unified shell solution.
   * @param path Path including search and hash to a unified shell solution
   * url.
   */ /**
   * Launch 404 page from anywhere
   */ /**
   * Called when user needs to reload iframe URL.
   */ constructor(params, configuration){
        super();
        $47f9a2da236c5b90$var$_defineProperty(this, "ai", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "app", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "appId", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "appApi", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "cache", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "component", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "consent", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "configured", false);
        $47f9a2da236c5b90$var$_defineProperty(this, "featureFlags", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "lastConfigurationPayload", null);
        $47f9a2da236c5b90$var$_defineProperty(this, "messenger", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "modules", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "page", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "permissions", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "pulse", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "session", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "settings", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "shell", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "user", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "appContainer", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "customEnvLabel", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "customButtons", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "customSearch", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "digitalData", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "feedback", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "helpCenter", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "logoutUrl", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "nps", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "showLanguagePicker", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "showRolesPicker", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "sidebar", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "sidenav", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "solution", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "subOrgs", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "workspaces", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "authExpired", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "openInNewTab", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "shellRedirect", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "generateShellUrl", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "blockNavigation", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "done", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "notFound", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "iframeReload", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "send", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "addShellPlaceholder", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "metrics", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "configManager", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "helpCenterApi", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "topbar", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "internal", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "engine", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "userAgent", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "document", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "runImmediately", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "onCustomProfileClick", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "skipMenuList", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "onReadySet", false);
        $47f9a2da236c5b90$var$_defineProperty(this, "pendingConfig", void 0);
        $47f9a2da236c5b90$var$_defineProperty(this, "onExternalHistoryChange", (path)=>{
            this.metrics.event("Runtime.onExternalHistoryChange", path);
            this.emit("history", {
                path: path,
                type: "external"
            });
        });
        $47f9a2da236c5b90$var$_defineProperty(this, "receive", (event)=>{
            const data = event.data || {};
            const type = data.type;
            const value = data.value;
            const changed = data.changed;
            switch(type){
                case $lg0Zk.Events.CONFIGURE:
                    // Make the changed array accessible to SPAs.
                    value.changedProperties = changed; // If there are changed values, send change events
                    this.engine.onConfigure(this, value, this.internal);
                    break;
                case $lg0Zk.Events.CUSTOM_FEEDBACK:
                    this.metrics.info("Runtime.onUseCustomFeedback");
                    this.emit("customFeedback", {});
                    break;
                case $lg0Zk.Events.CUSTOM_PROFILE_CLICK:
                    this.onCustomProfileClick && this.onCustomProfileClick(value);
                    break;
                case $lg0Zk.Events.CUSTOM_SEARCH:
                    this.emit("customSearch", value);
                    break;
                case $lg0Zk.Events.CUSTOM_PROFILE_BUTTON_CLICK:
                case $lg0Zk.Events.CUSTOM_HELP_BUTTON_CLICK:
                    this.emit("customButtonClick", data);
                    break;
                case $lg0Zk.Events.GLOBAL_DIALOG_OPEN:
                    $47f9a2da236c5b90$var$setHidden(value, this.document.body);
                    break;
                case $lg0Zk.Events.HISTORY:
                    this.onExternalHistoryChange(value);
                    break;
                case $lg0Zk.Events.NPS:
                    this.metrics.analytics.trackEvent({
                        action: "submit",
                        element: value,
                        feature: "nps",
                        type: "nps",
                        widget: {
                            name: "nps",
                            type: "form"
                        }
                    });
                    break;
                case $lg0Zk.Events.SKIP_MENU_FOCUS:
                    this.setKeyboardFocus(value);
                    break;
                case $lg0Zk.Events.SKIP_MENU_GET_LIST:
                    this.getSkipMenuList();
                    break;
                case $lg0Zk.Events.USER_INPUT:
                    this.engine.onShellUserInput(value);
                    break;
            }
        });
        const { appId: appId, configManager: configManager, engine: engine, helpCenterApi: helpCenterApi, internal: internal, messenger: messenger, metricsApi: metricsApi, pageApi: { addShellPlaceholder: addShellPlaceholder, page: page }, topbar: topbar, window: window } = params;
        const { app: app, modules: { ai: ai, appApi: appApi, cache: cache, component: component, consent: consent, featureFlags: featureFlags, modules: modules, permissions: permissions, pulse: pulse, session: session, settings: settings, shell: shell, user: user } } = engine;
        const { document: document, location: location, navigator: navigator, setTimeout: setTimeout } = window;
        configManager.clear(); // Mirroed page methods
        const { blockNavigation: blockNavigation, done: done, generateShellUrl: generateShellUrl, iframeReload: iframeReload, notFound: notFound, openInNewTab: openInNewTab, shellRedirect: shellRedirect } = page;
        this.blockNavigation = blockNavigation;
        this.openInNewTab = openInNewTab;
        this.shellRedirect = shellRedirect;
        this.generateShellUrl = generateShellUrl;
        this.iframeReload = iframeReload;
        this.done = done;
        this.notFound = notFound;
        this.addShellPlaceholder = addShellPlaceholder;
        this.appId = appId;
        this.send = messenger.send;
        this.engine = engine;
        this.internal = internal;
        this.ai = ai();
        this.app = app;
        this.appApi = appApi();
        this.cache = cache();
        this.component = component();
        this.consent = consent();
        this.featureFlags = featureFlags();
        this.helpCenterApi = helpCenterApi;
        this.modules = modules();
        this.page = page;
        this.permissions = permissions();
        this.pulse = pulse();
        this.session = session();
        this.settings = settings();
        this.shell = shell();
        this.user = user();
        this.topbar = topbar;
        this.runImmediately = (handler)=>setTimeout(handler, 0);
        this.userAgent = navigator.userAgent;
        this.document = document;
        this.authExpired = this.user.authExpired;
        this.metrics = metricsApi.create("exc.module-runtime");
        this.messenger = messenger;
        this.configManager = configManager; // Adds a Metrics filter to create performance marks for events listed in RUNTIME_MARKED_EVENTS
        (0, $lg0Zk.markEventsPerformance)(window, $47f9a2da236c5b90$var$RUNTIME_MARKED_EVENTS, (event)=>`rt_${event.toLowerCase().replace(/[ ().\-&]+/g, "_")}`);
        this.metrics.event("Runtime.constructed");
        this.messenger.on("message", this.receive);
        const { href: href, pathname: pathname, hash: hash, search: search } = location;
        this.send($lg0Zk.Events.READY, {
            configuration: configuration,
            hash: hash,
            href: href,
            pathname: pathname,
            search: search
        });
        configManager.setupConfig(this, [
            "appContainer",
            "customEnvLabel",
            "customButtons",
            "customSearch",
            "digitalData",
            "favicon",
            "feedback",
            "helpCenter",
            "logoutUrl",
            "modal",
            "nps",
            "preventDefaultCombos",
            "showLanguagePicker",
            "showRolesPicker",
            "sidebar",
            "sidenav",
            "solution",
            "spinner",
            "subOrgs",
            "title",
            "unloadPromptMessage",
            "workspaces"
        ], (apiName)=>{
            [
                "sidebar",
                "nps"
            ].includes(apiName) && this.send($lg0Zk.Events.DEPRECATION_WARNING, apiName);
        }); // Add the viewport takeover DOM element to the page if enabled in the
        // config.
        if (configuration && "canTakeover" in configuration) {
            this.send($lg0Zk.Events.DEPRECATION_WARNING, "canTakeover");
            configuration.canTakeover && this.addShellPlaceholder();
        }
        engine.onPageChange(this);
    }
    on(type, handler) {
        super.on(type, handler);
        if (type === "ready") {
            this.onReadySet = true;
            if (this.pendingConfig) // Re-emit the last config in the next event loop.
            this.runImmediately(()=>{
                this.emit("ready", this.pendingConfig);
                delete this.pendingConfig;
            });
        }
    }
    sendConfig(config) {
        const event = this.configured ? "configuration" : "ready";
        this.metrics.event(`Runtime.${event}`, config);
        this.emit(event, config);
        if (!this.onReadySet) {
            this.metrics.event(`Runtime.readyBeforeListen`, {
                level: $fBGTm.Level.WARN
            });
            this.pendingConfig = config;
        }
    }
    set config(config) {
        this.configManager.set(config);
    }
    get config() {
        return this.configManager.config();
    }
    /**
   * Stores a customHeroClick function for later use
   * and sends a post message to the Sandbox that a customHeroClick
   * exists.
   * @param fn Callback function for custom behavior from solution.
   */ set heroClick(fn) {
        this.topbar.onHeroClick(fn);
    }
    /**
   * Stores a profileClick function which is
   * invoked when a user clicks and custom profile buttons in the User Profile
   * view in Shell.
   * @param fn Callback function for custom behavior from solution.
   */ set customProfileClick(fn) {
        this.onCustomProfileClick = fn;
    }
    /**
   * Allows a solution to open a Shell menu by sending a
   * post message to the Sandbox.
   * @param menuKey A string to identify which shell menu to open.
   * Acceptable values include 'helpCenter'.
   * @param menuData An object data the menu will need.
   */ openMenu(menuKey, menuData) {
        if (menuKey === "helpCenter") this.helpCenterApi.open(menuData);
        else this.metrics.warn(`Runtime: unknown openMenu key ${menuKey}`);
    }
    /**
   * Allows the a11y skip menu to set focus on an element inside the iframe
   * @param dataKey A string to identify which element to focus
   */ setKeyboardFocus(dataKey) {
        const node = (this.skipMenuList || {})[dataKey];
        if (node) {
            // Right now "main" is not part of the sequential keyboard
            // navigation, so -1 is the value we want in the "main" case
            // as we programmatically move focus while not adding "main"
            // to the sequential order
            node.tabIndex = -1;
            node.focus();
            node.addEventListener("blur", ()=>node.removeAttribute("tabIndex"), {
                once: true
            });
        }
    }
    /**
   * Scrubs the DOM inside the iframe for a11y skip menu elements.
   * Currently finds the main landmark (if it exists), stores the list, and
   * sends a post message to the Sandbox with the skip menu options.
   */ getSkipMenuList() {
        let skipMenuList = null; // Get the main landmark or body of the solution for the skip menu list
        // Check the browser because Safari prevents programatic focusing
        // (https://github.com/braintree/braintree-web/issues/490) and 'Safari'
        // is also listed in the user agent string for other browsers ('Chrome'
        // also catches Edge and Opera browswers, find out more here
        // https://www.whatismybrowser.com/guides/the-latest-user-agent)
        // We fallback in Sandbox in the case of Safari
        const main = this.userAgent.includes("Firefox") || this.userAgent.includes("Chrome") ? this.document.querySelector('main, [role="main"], body') : null;
        if (main) {
            this.skipMenuList = {
                mainLandmark: main
            };
            skipMenuList = [
                {
                    id: "mainLandmark",
                    label: "Skip to main content"
                }
            ];
        }
        this.send($lg0Zk.Events.SKIP_MENU_SET_LIST, {
            skipMenuList: skipMenuList
        });
    }
}
$47f9a2da236c5b90$exports.Runtime = $47f9a2da236c5b90$var$Runtime;


function $95436b040e0d5b18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $95436b040e0d5b18$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $95436b040e0d5b18$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $95436b040e0d5b18$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $95436b040e0d5b18$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $95436b040e0d5b18$var$getRuntimeClass = (params)=>class Runtime extends $47f9a2da236c5b90$exports.Runtime {
        constructor(configuration){
            super(params, configuration);
        }
    };

const $95436b040e0d5b18$var$bootstrapRuntime = (win, postMessageFn, activeAppId)=>{
    const appId = activeAppId || new URL(win.location.href).searchParams.get("appId") || undefined;
    const metricsApiContainer = (0, $95436b040e0d5b18$var$_metrics.default)(win);
    const { metricsApi: metricsApi, metricsInternal: { configureMetrics: configureMetrics } } = metricsApiContainer;
    const messenger = new $95436b040e0d5b18$var$_Messenger.default(metricsApiContainer, win, postMessageFn, appId);
    const configManager = (0, $95436b040e0d5b18$var$_config.default)(messenger);
    const pageApi = (0, $95436b040e0d5b18$var$_page.default)(messenger, configManager, metricsApi, win);
    const engine = (0, $95436b040e0d5b18$var$_runtimeDeferred.default)(messenger, configManager, [
        pageApi
    ], metricsApi, win);
    const sidebar = (0, $95436b040e0d5b18$var$_sidebar.default)(messenger, configManager);
    const topbar = (0, $95436b040e0d5b18$var$_topbar.default)(messenger, configManager);
    const orgSwitcher = (0, $95436b040e0d5b18$var$_orgswitcher.default)(configManager);
    const nps = (0, $95436b040e0d5b18$var$_nps.default)(messenger, configManager);
    const helpCenterApi = (0, $95436b040e0d5b18$var$_helpcenter.default)(messenger, configManager, metricsApi);
    const userProfile = (0, $95436b040e0d5b18$var$_userprofile.default)(messenger, configManager);
    const { configureNetwork: configureNetwork, network: network } = (0, $95436b040e0d5b18$var$_network.default)(metricsApi, win, engine, messenger);
    const internal = (0, $95436b040e0d5b18$var$_internal.default)(configureNetwork, metricsApiContainer, win, engine, messenger);
    const runtimeClass = $95436b040e0d5b18$var$getRuntimeClass({
        appId: appId,
        configManager: configManager,
        engine: engine,
        helpCenterApi: helpCenterApi,
        internal: internal,
        messenger: messenger,
        metricsApi: metricsApi,
        network: network,
        nps: nps,
        orgSwitcher: orgSwitcher,
        pageApi: pageApi,
        sidebar: sidebar,
        topbar: topbar,
        userProfile: userProfile,
        window: win
    });
    const runtimeInstance = {
        instance: undefined
    };
    function defaultFn(configuration) {
        runtimeInstance.instance || (runtimeInstance.instance = new runtimeClass(configuration));
        return runtimeInstance.instance;
    }
    const { env: env = "" } = win.config || {};
    configureMetrics({
        environment: [
            "STAGE",
            "PROD"
        ].includes(env) ? env.toLowerCase() : undefined
    });
    engine.waitForInit(runtimeInstance); // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { app: app, modules: { networkPrefetch: networkPrefetch, ...globalModules } } = engine;
    const { page: page } = pageApi;
    const nest = (nestedWin)=>Promise.resolve().then(function() {
            return (parcelRequire("3QPMY"));
        }).then((res)=>$95436b040e0d5b18$var$_interopRequireWildcard(res)).then(({ nestModuleRuntime: nestModuleRuntime })=>nestModuleRuntime(nestedWin, win));
    win["exc-module-runtime"] = {
        ...globalModules,
        app: app,
        default: defaultFn,
        helpCenter: helpCenterApi,
        internal: internal,
        metrics: metricsApi,
        nest: nest,
        network: network,
        nps: nps,
        orgSwitcher: orgSwitcher,
        page: page,
        Runtime: runtimeClass,
        sidebar: sidebar,
        topbar: topbar,
        userProfile: userProfile
    };
};
const $95436b040e0d5b18$var$bootstrapShell = (win)=>{
    const metricsApiContainer = (0, $95436b040e0d5b18$var$_metrics.default)(win);
    const { metricsApi: metrics } = metricsApiContainer;
    const { configureNetwork: configureNetwork, network: network } = (0, $95436b040e0d5b18$var$_network.default)(metrics, win);
    const internal = (0, $95436b040e0d5b18$var$_internal.default)(configureNetwork, metricsApiContainer, win);
    win["exc-module-runtime"] = {
        bootstrapRuntime: $95436b040e0d5b18$var$bootstrapRuntime,
        internal: internal,
        metrics: metrics,
        network: network
    };
}; // eslint-disable-next-line no-restricted-globals
(0, $eYPZ6.isShell)(window) ? $95436b040e0d5b18$var$bootstrapShell(window) : $95436b040e0d5b18$var$bootstrapRuntime(window);

})();
//# sourceMappingURL=runtime.2285bdb1.js.map
